{
  "common": {
    "productNoun": {
      "form": "formulaire",
      "survey": "sondage",
      "quiz": "questionnaire"
    },
    "productNounCapitalized": {
      "form": "Formulaire",
      "survey": "Sondage",
      "quiz": "Questionnaire"
    },
    "urlField": {
      "settingsTitle": "Définissez les paramètres du champ URL",
      "description": "Choisissez les types d'URL autorisés dans ce champ.",
      "allowAllDomains": "Autorisez tous les domaines",
      "allowAllDomainsDescription": "Toute URL valide est acceptée.",
      "allowOnlyDomains": "Autorisez uniquement ces domaines",
      "allowOnlyDomainsDescription": "Tout le reste est refusé.",
      "blockDomains": "Bloquez ces domaines",
      "blockDomainsDescription": "Tout le reste est accepté.",
      "domainsAllowed": "Domaines autorisés",
      "domainsBlocked": "Domaines bloqués",
      "domainPlaceholder": "p. ex., exemple.com",
      "domainPlaceholderAdd": "Ajouter un autre",
      "domainHint": "Taper un domaine et appuyer sur Entrée pour ajouter.",
      "invalidDomain": "Entrez un domaine valide sans http://, https:// ou chemin d'accès.",
      "domainRequired": "Ajoutez au moins un domaine pour cette option.",
      "singleUrlInfo": "Une seule URL est prise en charge par champ. Pour capturer plusieurs URL, créez des champs distincts."
    },
    "px": "px",
    "px_uppercase": "PX",
    "seconds": "secondes",
    "other": "-- Autres --",
    "customFieldExistsError": "Champ personnalisé avec ce nom existe déjà",
    "requiredField": "Ce champ est obligatoire.",
    "uniqueKeyNotUniqueError": "Cette clé n'est pas unique",
    "save": "Sauvegarder",
    "saving": "Sauvegarde en cours",
    "typeAnOption": "Saisissez une option",
    "unsaved": "Non enregistré",
    "noSubmissionsFound": "Aucune soumission trouvée",
    "sortBy": "Trier par",
    "clearAll": "Tout effacer",
    "submitSurvey": "Soumettre le sondage",
    "select": "Sélectionner",
    "data": "Données",
    "enterAmount": "Saisissez le montant",
    "disqualifyAfterSubmitLower": "Disqualifier après soumission",
    "errorRetryAgain": "Erreur, réessayez",
    "savedSuccessfully": "Enregistré avec succès!",
    "couldntSaveChanges": "Impossible d'enregistrer les modifications. Veuillez réessayer.",
    "emailNotificationSettingsUpdated": "Vos paramètres de notification par courriel ont été mis à jour.",
    "autoResponderSettingsUpdated": "Vos paramètres du répondeur automatique ont été mis à jour.",
    "bubbleRadioStyleImageAlt": "Style radio à bulles",
    "standardRadioStyleImageAlt": "Style radio standard",
    "recurringFrequency": {
      "once": "Une fois",
      "daily": "Quotidiennement",
      "weekly": "Hebdomadaire",
      "monthly": "Mensuel",
      "yearly": "Annuel"
    },
    "saveExitConfirmationSubText": "Afficher une fenêtre de confirmation lorsque l'utilisateur quitte la page.",
    "yes": "Oui",
    "no": "Non",
    "updated": "Mis à jour",
    "new": "Nouveau",
    "title": "Titre",
    "openSettings": "Ouvrir les paramètres",
    "cloneField": "Cloner le champ",
    "removeField": "Supprimer le champ",
    "description": "Description",
    "cannotAddThisField": "Ce champ ne peut pas être ajouté.",
    "cannotAddThisFieldSubheading": "Ce {product} utilise déjà {existing} champs. Supprimer tous les champs de 1 objet avant d'ajouter {attempted} champs.",
    "overallOnly": "Globalement seulement",
    "nextSlideDefault": "Diapositive suivante (par défaut)",
    "nextQuestion": "Question suivante",
    "searchAddress": "Recherchez une adresse",
    "recurringDonation": "Don récurrent",
    "recurringDonationDay": "Don récurrent d'une journée",
    "recurringDonationWeek": "Don récurrent hebdomadaire",
    "recurringDonationMonth": "Don récurrent d'un mois",
    "recurringDonationYear": "Don récurrent d'un an",
    "integrate": "Intégrer",
    "share": "Partager",
    "email": "Courriel",
    "connections": "Connexions",
    "comingSoon": "Bientôt disponible",
    "newWorkflow": "Nouveau flux de travail",
    "workflow": "Flux de travail",
    "funnel": "Entonnoir",
    "website": "Site Web",
    "notConnectedToWorkflow": "Cet élément {asset} n'est pas encore connecté au flux de travail",
    "workflowEmptyDescription": "Envoyez un courriel de confirmation, avisez votre équipe ou identifiez les nouveaux prospects lorsqu'une personne envoie l'élément {asset}.",
    "workflowName": "Nom du flux de travail",
    "workflowStatus": "Statut",
    "workflowLastUpdated": "Dernière mise à jour",
    "workflowStatusPublished": "Publié",
    "workflowStatusDraft": "Ébauche",
    "openInNewTab": "Ouvrir dans un nouvel onglet",
    "moreActions": "Plus d'actions",
    "rename": "Renommer",
    "workflowsShowingFirst": "Affichage des {count} premiers flux de travail",
    "retry": "Réessayer",
    "workflowsLoadError": "Impossible de charger les flux de travail liés.",
    "renameWorkflow": {
      "title": "Renommer le flux de travail",
      "description": "Donnez à ce flux de travail un nom qui indique à quoi il sert.",
      "nameLabel": "Nom",
      "namePlaceholder": "Entrer le nom du flux de travail",
      "nameRequired": "Le nom du flux de travail est requis"
    },
    "deleteWorkflow": {
      "title": "Supprimer le flux de travail",
      "confirmDescription": "Voulez-vous vraiment supprimer « {name} »? Une fois supprimé, il sera transféré à l'onglet « Supprimé » et sera définitivement supprimé après 30 jours."
    },
    "workflowRenamed": {
      "title": "Flux de travail renommé",
      "description": "Ce flux de travail s'appelle maintenant « {name} »."
    },
    "workflowDeleted": {
      "title": "Flux de travail supprimé",
      "description": "« {name} » a été supprimé."
    },
    "workflowRenameFailed": {
      "title": "Échec du renommage du flux de travail",
      "description": "Veuillez réessayer plus tard."
    },
    "workflowDeleteFailed": {
      "title": "Échec de la suppression du flux de travail",
      "description": "Veuillez réessayer plus tard."
    },
    "exampleDomain": "exemple.com",
    "preview": "Aperçu",
    "back": "Retour",
    "close": "Fermer",
    "goHighLevel": "GoHighLevel",
    "openMediaLibrary": "Ouvrir la bibliothèque multimédia",
    "alert": "Alerte",
    "proceed": "Poursuivre",
    "confirm": "Confirme",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "embed": "Intégrer",
    "link": "Lien",
    "linkModal": {
      "title": "Insérer un lien",
      "urlLabel": "URL",
      "urlPlaceholder": "https://www.exemple.com",
      "invalidUrl": "URL non valide"
    },
    "iframeEmbed": "Intégration Iframe",
    "styles": "Styles",
    "options": "Options",
    "quickAdd": "Ajout rapide",
    "customFields": "Champs personnalisés",
    "addObjectFields": "Ajouter des Domaines d'Objet",
    "personalInfo": "Information personnelle",
    "contactInfo": "Coordonnées",
    "submit": "Soumettre",
    "address": "Adresse",
    "customized": "Sur mesure",
    "layout": "Mise en page",
    "showLabel": "Afficher l’étiquette",
    "showImage": "Afficher l'image",
    "imageLayout": "Mise en page de l'image",
    "imageLayoutSettings": "Paramètres de mise en page de l’image",
    "imageLayoutMode": "Mode de mise en page de l'image",
    "surveyDefault": "Paramètres par défaut du sondage",
    "independent": "Autonome",
    "image": "Image",
    "desktop": "Bureau",
    "mobile": "Mobile",
    "desktopImage": "Image pour ordinateur",
    "mobileImage": "Image pour téléphone",
    "uploaded": "Téléversé",
    "changeImage": "Changer l'image",
    "uploadImage": "Téléverser une image",
    "remove": "Supprimer",
    "background": "Arrière-plan",
    "buttonBackground": "Contexte du Bouton",
    "gradient": "Dégradée",
    "type": "Type",
    "linear": "Linéaire",
    "radial": "Radial",
    "angular": "Angulaire",
    "angle": "Angle",
    "stops": "Arrêts",
    "startColor": "Couleur de début",
    "endColor": "Couleur de fin",
    "addColor": "Ajouter une couleur",
    "fontColour": "Couleur de la Police",
    "textFontColour": "Couleur de la police du texte",
    "subTextFontColour": "Couleur de la police du sous-texte",
    "selectThemes": "Sélectionner un thème",
    "selectOne": "Sélectionnez une option",
    "enableIcon": "Activer l'icône",
    "iconType": "Type d'icône",
    "iconPlacement": "Placement des Icônes",
    "filled": "Rempli",
    "textOnly": "Corps uniquement",
    "border": "Bordure",
    "borderType": "Type de bordure",
    "cornerRadius": "Rayon de l'angle",
    "width": "Largeur",
    "padding": "Remplissage",
    "top": "Haut",
    "bottom": "Bas",
    "left": "Gauche",
    "right": "Droite",
    "center": "Centre",
    "default": "Par défaut",
    "formDefault": "Formulaire par défaut",
    "shadow": "Ombre",
    "color": "Couleur",
    "horizontal": "Horizontal",
    "vertical": "Vertical",
    "blur": "Flou",
    "spread": "Diffusion",
    "fieldStyle": "Style de champ",
    "fontColor": "Couleur de la police",
    "inputTextFillColor": "Couleur de remplissage du texte de la zone de saisie",
    "inputTextColor": "Couleur du texte de la zone de saisie",
    "primaryColor": "Couleur primaire",
    "primaryColorTooltip": "Contrôle la couleur pour l’état de survol et l’état actif.",
    "primaryColorTooltipLearnMore": "En savoir plus",
    "inputTextColorTooltip": "Contrôle la couleur du texte saisi dans les champs.",
    "mapPrimaryColorToButtonColor": "Associer la couleur primaire à la couleur du bouton",
    "label": "Étiquette",
    "fontFamily": "Famille de polices",
    "size": "Taille",
    "weight": "Poids",
    "fontWeightTooltip": "Applicable dans le cas des paragraphes",
    "fontWeightOptions": {
      "thin": "100 - Mince",
      "extraLight": "200 - Très clair",
      "light": "300 - Clair",
      "normal": "400 - Normal",
      "medium": "500 - Moyen",
      "semiBold": "600 - Semi-gras",
      "bold": "700 - Gras"
    },
    "placeholder": "Espace réservé",
    "customCSS": "CSS personnalisé",
    "backgroundImage": "Image d’arrière-plan",
    "headerImage": "Image d'en-tête",
    "miscellaneous": "Divers",
    "agencyBranding": "Image de marque de l’agence",
    "imageUploadMessage": "Cliquez ou faites glisser un fichier vers cette zone pour le téléverser.",
    "backgroundImageTooltipMessage": "L'image d'arrière-plan est destinée à couvrir toute la page, offrant ainsi une toile de fond visuellement attrayante pour le formulaire. Pour afficher l’image d’arrière-plan, cliquez sur l’option Aperçu.",
    "headerImageTooltipMessage": "L’image d’en-tête est conçue pour couvrir toute la largeur du formulaire et reste positionnée en haut du formulaire. Pour afficher l'image d'en-tête, cliquez sur l'option Aperçu.",
    "onSubmit": "Lors de la soumission",
    "facebookPixelID": "Identifiant de pixel Facebook",
    "facebookPixelFunnelLabel": "Utilisez-vous ceci dans un entonnoir ?",
    "facebookPixelFunnelText": "Laissez-le vide : les paramètres Pixel et de consentement aux témoins de l'entonnoir prendront le relais.",
    "facebookPixelEmbedLabel": "Intégration sur un autre site?",
    "facebookPixelEmbedText": "Choisissez comment le consentement aux témoins est géré à l'étape du code d'intégration.",
    "facebookPixelConsentCallout": "Le consentement aux témoins est défini par intégration, sous",
    "facebookPixelConsentCalloutLink": "Intégrer → Code d'intégration",
    "facebookPixelEvents": "Événements du pixel Facebook",
    "onpageView": "Affichage sur la page",
    "stickyContact": "Contact collant",
    "stickyContactMessage": "Mémorise et remplit automatiquement les coordonnées lorsque l'utilisateur revient sur le même appareil et le même navigateur.",
    "generateSubmissionDocument": "Générez le document de soumission",
    "generateSubmissionDocumentMessage": "Créez automatiquement un fichier PDF imprimable de chaque soumission et attachez-le aux documents du contact",
    "saveQuizSubmissionAsPdf": "Enregistrez la soumission du quiz au format PDF",
    "saveQuizResultAsPdf": "Enregistrez le résultat du quiz au format PDF",
    "showSubmissionInConversationsFeed": "Créer une conversation lors de la soumission",
    "showSubmissionInConversationsFeedMessage": "Créez automatiquement un fil de conversation lorsque ce formulaire est soumis, ce qui vous permet de faire un suivi par courriel, SMS ou d'autres canaux depuis l'onglet Conversations.",
    "fieldDescription": "Description du champ",
    "fieldTitle": "Titre du champ",
    "queryKey": "Clé de requête",
    "querykeyTooltipMessage": "La clé de requête peut être utilisée comme paramètre URL pour remplir ce champ.",
    "required": "Obligatoire",
    "hidden": "Caché",
    "hiddenValue": "Valeur cachée",
    "enableCountryPicker": "Activer le sélecteur de pays",
    "altText": "Texte de remplacement",
    "optionImageAlt": "Image de l'option",
    "bannerAlt": "bannière",
    "avatarAlt": "Nom de l'avatar",
    "alignment": "Alignement",
    "imageWidth": "Largeur de l’image",
    "imageHeight": "Hauteur de l'image",
    "logic": "Logique",
    "pleaseInput": "Veuillez saisir",
    "editHTML": "Modifier l'HTML",
    "textStyle": "Style du texte",
    "subText": "Sous-texte",
    "text": "Texte",
    "buttonStyle": "Style du bouton",
    "fullWidth": "Pleine largeur",
    "htmlMessage": "Placez le code HTML personnalisé ici.",
    "htmlEditorHeader": "JAVASCRIPT / HTML PERSONNALISÉ",
    "htmlEditorBodyMessage": "Ajoutez votre code ici.",
    "scriptAdded": "Script ajouté!",
    "sourceAddedForm": "Source « Nom du formulaire »",
    "sourceAddedSurvey": "Source « Nom du sondage »",
    "sourceAddedQuiz": "Source « Nom du questionnaire »",
    "yesSave": "Oui, sauvegarder",
    "cancelKeep": "Annuler, conserver",
    "done": "Terminé",
    "addElement": "Ajouter un élément",
    "addUrlLike": "Veuillez inclure des URL valides telles que",
    "doNotAddRelativePath": "N'ajoutez pas de chemins relatifs comme",
    "or": "ou",
    "addCustomFields": "Ajouter des champs personnalisés",
    "customFieldSearch": "Rechercher par nom",
    "selectedCount": "{count} sélectionné(s)",
    "noFieldsFound": "Aucun champ trouvé",
    "noFieldsMatchQuery": "Aucun champ ne correspond à « {query} ». Essayez un autre terme ou créez un nouveau champ.",
    "clearSearch": "Effacer la recherche",
    "addFieldWithCount": "Ajouter {count} champ | Ajouter {count} champs",
    "noFieldsYet": "Aucun champ pour le moment",
    "noFieldsForObject": "Cet objet n'a pas encore de champs. Créez-en un pour commencer.",
    "createField": "Créer un champ",
    "enterSourceValue": "Saisis la valeur source",
    "shortLabel": "Étiquette courte",
    "shortLabelPlaceholder": "Police",
    "labelPlaceholder": "Type une étiquette",
    "imagePlaceholder": "Image",
    "fillValuesPlaceholder": "Ajouter des valeurs",
    "customCSSTooltip": "La feuille de style personnalisée a préséance sur le style de forme et les thèmes et peut avoir un impact sur le style du thème.",
    "fontFamilyTooltip": "Le générateur prend en charge tous les types de polices si vous ne les voyez pas dans la liste. Veuillez la rechercher dans le menu déroulant.",
    "angleTooltip": "Contrôle la direction du dégradé. 0° est à droite, 90° est en bas, 180° est à gauche, 270° est en haut.",
    "useGDPRCompliantFont": "Utilisez une police conforme au RGPD.",
    "enableTimezone": "Activer le fuseau horaire",
    "inputStyle": "Style d’entrée",
    "conditionalLogicAlertOnSubmit": "La logique conditionnelle aura préséance sur le message / rediriger ici.",
    "conditionalLogicAlertOnShowHide": "La logique conditionnelle aura préséance sur les paramètres cachés ici.",
    "placeholderFacebookPixelIdInput": "Saisir l'identifiant de pixel Facebook",
    "doNotShowMessage": "Ne plus afficher",
    "creatingForm": "OK",
    "creatingSurvey": "Créez votre Sondage...",
    "creatingQuiz": "Créez votre quiz...",
    "errorCreatingForm": "Une erreur s'est produite lors de votre formulaire. Veuillez réessayer.",
    "errorCreatingSurvey": "Là a été une erreur Veuillez réessayer.",
    "errorCreatingQuiz": "Une erreur s'est produite lors de la création de votre quiz. Veuillez réessayer.",
    "redirectMessage": "Vous serez redirigé vers :",
    "themes": {
      "themes": "Thèmes",
      "alertThemeMessage": "Le changement de thème entraîne la perte de toutes les modifications de style en cours.",
      "useTheme": "Utiliser le thème",
      "removeTheme": "Supprimer le thème"
    },
    "box": "Case",
    "line": "Ligne",
    "message": "Message",
    "openUrl": "Rediriger vers une URL",
    "borderTypeList": {
      "dotted": "Pointillés",
      "dashed": "Tiretés",
      "solid": "Ligne continue",
      "none": "Aucun"
    },
    "button": "Bouton",
    "emailNotification": "Notification par courriel",
    "emailNotificationSubheader": "Recevoir un courriel lorsque quelqu'un remplit votre formulaire",
    "subject": "Objet",
    "emailTo": "Courriel (À)",
    "senderName": "Nom de l’expéditeur",
    "senderNameWarning": "Votre (nom de sous-compte) sera ajouté si ce champ est laissé vide.",
    "emailError": "Au moins une adresse courriel est obligatoire",
    "emailTooltip": "Entrez une ou plusieurs adresses courriel qui devraient recevoir cette alerte de soumission de formulaire. La première adresse est placée dans le champ « À » ; les adresses supplémentaires sont traitées comme « CC ».",
    "emailTooltipForm": "Entrez une ou plusieurs adresses courriel qui devraient recevoir cette alerte de soumission de formulaire. La première adresse est placée dans le champ « À » ; les adresses supplémentaires sont traitées comme « CC ».",
    "emailTooltipSurvey": "Veuillez entrer une ou plusieurs adresses courriel qui devraient recevoir cette alerte de soumission du sondage. La première adresse est placée dans le champ « À » ; les adresses supplémentaires sont traitées comme « CC ».",
    "emailTooltipQuiz": "Veuillez entrer une ou plusieurs adresses courriel qui devraient recevoir cette alerte de soumission de questionnaire. La première adresse est placée dans le champ « À » ; les adresses supplémentaires sont traitées comme « CC ».",
    "clear": "Effacer",
    "filter": "Filtre",
    "noResults": "Aucun résultat",
    "search": "Rechercher",
    "showNotificationsSettings": "Afficher les paramètres des notifications",
    "emailServicePaid": "Cette fonctionnalité est un service payant et entraînera des frais en fonction de votre utilisation.",
    "integration": "Intégration",
    "validation": {
      "fieldRequired": "Champ est obligatoire",
      "maxLengthExceeded": "Max' accord ({max}"
    },
    "securityValidation": {
      "title": "Problèmes de sécurité détectés. Ce qui suit n'est pas autorisé :",
      "cookieAccess": "Accès aux témoins de navigation détecté (document.cookie). Ceci n'est pas autorisé pour des raisons de sécurité.",
      "storageAccess": "localStorage.getItem() – la lecture depuis localStorage n'est pas autorisée.",
      "evalUsage": "L'utilisation de la fonction eval() n'est pas autorisée car elle peut exécuter du code arbitraire.",
      "dynamicFunction": "La création de fonctions dynamiques (new Function) n'est pas autorisée pour des raisons de sécurité.",
      "stringExecution": "Le passage de chaînes à setTimeout/setInterval n'est pas autorisé car cela peut exécuter du code arbitraire. Utilisez plutôt des références de fonction.",
      "unclosedTag": "Balise HTML non fermée détectée (par exemple, une balise <style> sans balise </style> de fermeture). Veuillez fermer toutes les balises avant de sauvegarder, sinon la page publiée pourrait ne pas se charger."
    },
    "products": {
      "subscriptionBadge": "Abonnement",
      "trialBadge": "{days} jours d'essai gratuit",
      "setupFee": "Frais d’installation uniques",
      "quantity": "Quantité",
      "productImageAlt": "Image du produit",
      "bumpIconAlt": "Icône complémentaire"
    },
    "payment": {
      "payments": "Paiements",
      "paymentProviders": "Fournisseurs de paiement",
      "paymentProvidersDescription": "Connectez un prestataire de paiement pour commencer à accepter des paiements.",
      "connectedProviders": "Fournisseurs connectés",
      "requireCreditCard": "Exiger une carte de crédit pour les commandes de 0 $",
      "requireCreditCardTooltip": "Lorsque cette option est activée, les clients doivent saisir une carte de crédit, même pour des achats de 0 $.",
      "connectProviders": "Connectez les prestataires",
      "loading": "Chargement en cours….",
      "generalTab": "Général",
      "productTab": "Produit",
      "connected": "Connecté",
      "connect": "Se connecter",
      "liveModeOn": "Mode en direct",
      "status": "Statut",
      "test": "Essai",
      "live": "En direct",
      "paymentFields": "Champs de paiement",
      "suggestAnAmount": "Proposer un montant",
      "recurringPayments": "Paiements Récurrents",
      "selectCurrency": "Sélectionner la devise",
      "tagActiveBGColor": "Couleur de l'étiquette active",
      "includeOtherAmount": "Inclure l'autre montant",
      "footerInfo": "Informations de pied de page",
      "paymentType": "Type de paiement",
      "sellProducts": "Vendre des produits",
      "customAmount": "Montant personnalisé",
      "collectPayment": "Percevoir le paiement",
      "generalSettings": "Champs généraux",
      "securePayments": "* 100 %.",
      "error": {
        "addMainProductFirst": "Ajoutez un produit PRIMAIRE en premier",
        "priceNotFoundForBumpProduct": "Prix trouvé pour le Produit à bosses",
        "productAlreadyAdded": "Produit déjà ajouté"
      },
      "product": {
        "addProduct": "Ajouter un produit",
        "productSettings": "Paramètres du produit",
        "bumpTag": "Complémentaire",
        "settingsAria": "Paramètres du produit",
        "deleteAria": "Supprimer le produit",
        "selectProduct": "Sélectionner un produit",
        "editThisProduct": "Pour modifier ce produit",
        "clickHere": "Cliquez ici",
        "show": "Afficher",
        "description": "Description",
        "image": "Image",
        "layoutSettings": "Paramètres de mise en page",
        "singleColumn": "Colonne unique",
        "twoColumn": "Deux colonnes",
        "threeColumn": "Trois colonnes",
        "maxProductError": "Nombre maximal de 20 produits autorisés dans un formulaire",
        "productSelectPlaceholder": "Veuillez sélectionner un produit.",
        "orderConfirmation": "Confirmation de commande",
        "orderConfirmationWarning": "La page de confirmation de commande s'affichera une fois le paiement effectué",
        "quantity": "Quantité",
        "createProduct": "Pour créer un produit",
        "noProductsAdded": "Aucun produit ajouté pour le moment",
        "productsWillShowHere": "Une fois que vous avez inclus des produits, ils s'afficheront ici",
        "chooseProductType": "Sélectionner Typede produit",
        "mainProduct": "PRIMAIRE",
        "primaryOffer": "Offre principale",
        "checkoutAddOn": "Module d'extension de paiement",
        "pricingOptions": "Options de tarification",
        "pricingOptionsPlaceholder": "Sélectionnez les options de tarification (par défaut : toutes)",
        "all": "TOUT",
        "addOrSelectProducts": "Ajoutez ou sélectionnez des produits",
        "onceYouAddProductsTheyWillShowUpRightHere": "Une fois que vous avez ajouté des produits, ils apparaîtront ici",
        "addProducts": "Ajouter des produits"
      },
      "bumProduct": {
        "price": "Prix",
        "variant": "Variante",
        "headline": "Titre",
        "otoHeadline": "OTO Titre",
        "otoText": "OK",
        "enableImage": "Activer Image",
        "imageMessage": "Nous saisirons l' Image par défaut",
        "orUploadADifferentImage": "Téléverser une autre Image",
        "bumpProducts": "Produits à bosses",
        "bumpProduct": "Produit à bosses",
        "enableBump": "Activer le bosse",
        "orderBumpStyle": "Personnaliser le Style",
        "classic": "Classique",
        "modern": "Aujourd'hui",
        "icon": "Icône",
        "bumpTemplate": "Sélectionner un Modèle",
        "highlightText": "Mise en page du corps",
        "showPrice": "Afficher le Prix",
        "bumpPriceColor": "Prix à bosses",
        "bumpIconColor": "Icône à bosses",
        "bumpBackgroundColor": "Contexte de la bosse",
        "highlightTextColor": "Mise en page du corps",
        "headlineColor": "Titre",
        "otoHeadlineColor": "OTO Titre",
        "otoTextColor": "OK",
        "bumpBorderColor": "Bordure de la bosse",
        "priceRequired": "Le prix est obligatoire",
        "headlineRequired": "Le titre est obligatoire",
        "otoHeadlineRequired": "Le titre de l’OTO est obligatoire",
        "otoTextRequired": "Le texte OTO est requis",
        "bumpProductTooltip": "Une . Les clients peuvent l'inclure avec un .",
        "templateOne": "Modèle 1",
        "templateTwo": "Modèle 2",
        "templateThree": "Modèle 3",
        "animationIcon": {
          "none": "Aucun",
          "arrow": "Flèche",
          "fire": "Incendre",
          "plus": "Plus",
          "giftBox": "Boîte à cocher",
          "timer": "Compte à rebours",
          "cracker": "Catégorisation",
          "snack": "Collant",
          "partyBalloon": "Groupe de danse",
          "flash": "Instantané",
          "money": "Monnaie",
          "spaceShuttle": "Transfert de Espace"
        }
      },
      "coupons": {
        "coupons": "Coupons",
        "enableCoupon": "Activer le coupon",
        "couponAlignment": "Alignement des coupons",
        "left": "Gauche",
        "right": "Droite",
        "fullWidth": "Pleine largeur",
        "tooltipMessage": "Définir la position de l'entrée du coupon à partir des types ci-dessous"
      }
    },
    "sellProductsAddress": {
      "shippingAddressDescription": "Utilise l'élément Adresse pour calculer les taxes en fonction de l'adresse du client.",
      "billingAddress": "Adresse de facturation",
      "billingRequiresAddress": "Ajouter un élément Adresse pour activer l’adresse de facturation. La facturation utilise ses champs d’adresse.",
      "billingSameAsShipping": "Adresse de facturation identique à l'adresse d'expédition",
      "phoneNumber": "Numéro de téléphone",
      "billingAddressEnableFailed": "Nous n'avons pas pu activer les champs de l'adresse de facturation. Veuillez réessayer d'enregistrer."
    },
    "addressSettings": {
      "autoComplete": "Remplissage automatique de l'adresse",
      "addressfields": "Champs d'adresse",
      "placeholderSearch": "Rechercher une adresse",
      "autoCompleteTooltip": "Permet de rechercher et de remplir automatiquement une adresse.",
      "streetAddress": "Adresse de la rue",
      "autoCompleteAddressTitle": "Finir Auto l'adresse",
      "newBadge": "Nouveau",
      "defaultLabel": "Adresse",
      "searchPlaceholder": "Rechercher des adresses",
      "mandataorySearch": {
        "title": "Obligatoire pour l'adresse in la barre de recherche",
        "primaryText": "Remplissage automatique uniquement pour Adresse de la rue",
        "secondaryText": "Quand il est activé, lorsqu'un utilisateur interagir avec le champ d'adresse, Ensuite, ils doivent comporter une adresse valide pour continuer.",
        "secondaryText1": "in"
      }
    },
    "autoResponder": "Répondeur automatique",
    "workflow": "Flux de travail",
    "workflowSubheader": "Automatisez ce qui se passe après la soumission d'un formulaire",
    "workflowTitle": "Créez votre propre flux de travail simple.",
    "workflowDescription": "Utilisez des flux de travail pour assurer le suivi des contacts après leur interaction avec votre formulaire. Par ex., leur envoyer un courriel ou un texto de suivi",
    "createWorkflow": "Créer un flux de travail",
    "workflowVisualAlt": "Flux de travail visuel",
    "autoResponderSubheader": "Envoyez un courriel automatique à la personne qui soumet le formulaire (le courriel comprend une copie des renseignements saisis dans le formulaire).",
    "replyToEmail": "Réponse au courriel",
    "open": "Ouvert",
    "won": "Réussi",
    "lost": "Perdu",
    "abandon": "Abandonner",
    "selectAPipeline": "Sélectionner un pipeline",
    "stage": "Étape",
    "status": "Statut",
    "opportunityValue": "Valeur de l’opportunité",
    "createNewPipeline": "Créer un nouveau pipeline",
    "editOpportunitySettings": "Modifier les paramètres de l'opportunité",
    "contact": "Contact",
    "opportunity": "Opportunité",
    "business": "Entreprise",
    "add": "Ajouter",
    "manage": "Gérer",
    "more": "Plus",
    "opportunityHeading": "Où voulez-vous que votre opportunité soit mise à jour?",
    "date": {
      "dateSettings": "Paramètres de date",
      "dateFormat": "Format de la date",
      "dateSeparator": "Séparateur de date",
      "dateFormatTooltipMessage": "Sélectionnez un format de date. D représente le jour, M les mois et Y l'année",
      "dateSeparatorTooltipMessage": "Sélectionnez un séparateur qui séparera le jour, le mois et l'année dans le format sélectionné dans Format de la date.",
      "disablePicker": "Désactiver le sélecteur"
    },
    "dateTime": {
      "tabGeneral": "Général",
      "tabFieldSettings": "Paramètres des champs",
      "collectHeading": "Sélectionnez ce que ce champ doit collecter.",
      "collectDate": "Date",
      "collectTime": "Heure",
      "collectDateTime": "Date et heure",
      "collectTypeLockedTooltip": "Le type de collecte ne peut être modifié qu'avant que le champ ne soit enregistré.",
      "placeholderTextPlaceholder": "Ajouter un texte d'espace réservé",
      "shortLabelPlaceholder": "Ajouter une étiquette courte",
      "fieldSettingsBanner": "Définissez la plage de dates ou d'heures autorisée, limitez les jours que les utilisateurs peuvent choisir et choisissez comment la valeur est affichée.",
      "allowedDateRange": "Plage de dates autorisées",
      "dateModeAny": "N'importe quelle date",
      "dateModeFuture": "Dates futures uniquement",
      "dateModePast": "Dates passées uniquement",
      "dateModeRange": "Plage de dates spécifique",
      "futureQuestion": "Quelles dates les utilisateurs peuvent-ils choisir?",
      "futureAny": "Toute date future",
      "futureAnyDesc": "Les utilisateurs peuvent choisir n'importe quelle date postérieure à la date actuelle. Par ex., planifier une réunion à tout moment l'année prochaine.",
      "futureBuffer": "Après le délai tampon",
      "futureBufferDesc": "Les utilisateurs ne peuvent sélectionner des dates qu'à partir d'un certain nombre de jours. Par ex., autoriser les réservations à partir de trois jours à compter d'aujourd'hui.",
      "futureBufferSuffix": "jours à compter d'aujourd'hui",
      "futureRolling": "Dans une fourchette de dates déterminée",
      "futureRollingDesc": "Les utilisateurs peuvent choisir des dates comprises dans une plage future définie. Par ex., autoriser les réservations dans les 30 prochains jours.",
      "futureRollingPrefix": "Prochains",
      "futureRollingSuffix": "jours",
      "rangeLabel": "Plage de dates spécifique",
      "rangeStart": "Date de début",
      "rangeEnd": "Date de fin",
      "availableDays": "Jours disponibles",
      "allowedTimeRange": "Plage horaire autorisée",
      "timeModeAny": "À tout moment",
      "timeModeRange": "Plage horaire spécifique",
      "timeRangeLabel": "Plage horaire spécifique",
      "timeStart": "Heure de début",
      "timeEnd": "Heure de fin",
      "timeFormatLabel": "Format de l'heure",
      "timeFormat24": "24 heures",
      "timeFormat12": "AM / PM",
      "timePlaceholder": "HH:MM",
      "defaultTimeLabel": "Heure par défaut",
      "defaultTimeHelper": "Pré-remplissez avec l'heure actuelle ou une heure personnalisée.",
      "defaultTimeNone": "Aucun",
      "defaultTimeCurrent": "Actuel",
      "defaultTimeCustom": "Personnalisé",
      "customTimeLabel": "Heure personnalisée",
      "customTimeError": "Saisissez une heure valide au format HH:MM.",
      "disableCalendarPopup": "Désactiver la fenêtre contextuelle du calendrier",
      "meridianAm": "AM",
      "meridianPm": "PM",
      "daysError": "Sélectionnez au moins un jour disponible.",
      "dateRangeError": "La date de fin doit être postérieure ou égale à la date de début.",
      "timeRangeError": "L'heure de fin doit être postérieure à l'heure de début.",
      "saveBlockedTitle": "Le champ de date et d'heure est incomplet.",
      "saveBlockedDescription": "Corrigez les erreurs de validation de date et d'heure mises en évidence avant d'enregistrer.",
      "weekday": {
        "mon": "Lun",
        "tue": "Mar",
        "wed": "Mer",
        "thu": "Jeu",
        "fri": "Ven",
        "sat": "Sam",
        "sun": "Dim"
      }
    },
    "restoreVersion": "Restaurer la version",
    "versionHistory": "Historique de la version",
    "versionPreviewTitle": "Aperçu de la version",
    "errorMessage": "Erreur, réessayez",
    "version": "Version :",
    "currentVersion": "Version actuelle",
    "messageStyling": "Style du message",
    "validateEmailHeader": "Valider le courriel",
    "validateEmailDescription": "Le bouton sera visible une fois que l'utilisateur aura saisi son courriel. Cette fonctionnalité est conçue pour vous aider à générer des prospects de qualité.",
    "verifyEmail": "Vérifiez le courriel",
    "validatePhoneHeader": "Valider le numéro de téléphone",
    "validatePhoneDescription": "Le bouton sera visible une fois que l'utilisateur aura saisi son numéro de téléphone. Cette fonctionnalité est conçue pour vous aider à générer des prospects de qualité.",
    "verifyPhone": "Vérifier le téléphone",
    "validatePhoneWarning": "Pour activer la vérification par mot de passe unique reçu par SMS, assurez-vous que votre numéro de téléphone est configuré dans tes paramètres de localisation.",
    "addAnotherTnc": "Ajouter d'autres conditions générales",
    "tnc1": "T & C 1",
    "tnc2": "Conditions générales 2",
    "deleteCaps": "SUPPRIMER",
    "deleteConfirmation": "Tapez SUPPRIMER pour confirmer",
    "marginPadding": "Marge et remplissage",
    "style": {
      "formLayoutType": "Type de formulaire",
      "layoutType": "Type de mise en page",
      "surveyType": "Type de sondage",
      "oneColumn": "Une colonne",
      "twoColumn": "Deux colonnes",
      "singleLine": "Ligne unique",
      "fieldWidth": "Largeur du champ",
      "labelAlignment": {
        "labelAlignment": "Alignement des étiquettes",
        "labelWidth": "Largeur de l'étiquette"
      },
      "fieldSpacing": "Espacement des champs",
      "imageFieldSpacing": "Espacement des images & des champs",
      "imageCornerRadius": "Rayon d'angle de l'image",
      "color": "couleur",
      "fontColor": "Couleur de la police",
      "inputBackgroundColor": "Couleur d'arrière-plan de la zone de saisie",
      "inputBorder": "Bordure de la zone de saisie",
      "layout": "Mise en page",
      "colorsAndBackground": "Couleurs et arrière-plan",
      "imageLayout": {
        "imageLayout": "Mise en page de l'image",
        "showImage": "Afficher l'image",
        "image": "Image",
        "desktop": {
          "topFixed": "Haut de page fixe",
          "leftCenter": "Centre gauche",
          "rightCenter": "Centre Droit",
          "leftFixed": "Fixé à gauche",
          "rightFixed": "Fixé à droite",
          "background": "Arrière-plan"
        },
        "mobile": {
          "header": "En-tête",
          "background": "Arrière-plan"
        }
      },
      "focusPoint": {
        "title": "Point focal",
        "reset": "Réinitialiser",
        "noImage": "Aucune image téléversée"
      },
      "advanceSettings": "Réglages avancés",
      "inputField": "Champ de saisie",
      "borderWidth": "Largeur de la bordure",
      "borderColor": "Couleur de bordure",
      "borderStyle": "Style de bordure",
      "fontSize": "Taille de la police",
      "fontWeight": "Poids de la police",
      "labelColor": "Couleur de l’étiquette",
      "placeholderColor": "Couleur de l'espace réservé",
      "shortLabelColor": "Couleur de l’étiquette courte"
    },
    "replyToTooltip": "Veuillez indiquer l'adresse électronique où les réponses à cette notification doivent être envoyées. Utilisez {'{'}{'{'}contact.email{'}'}{'}'} pour permettre aux destinataires de répondre directement à la personne qui a rempli le formulaire.",
    "content": "Contenu",
    "calculations": "Calculs",
    "uploadOptions": "Options de téléversement",
    "opportunitySettingsWarning": "Veuillez configurer les paramètres d’opportunité en cliquant sur le bouton Modifier les paramètres d’opportunité.",
    "startValue": "Valeur de début",
    "endValue": "Valeur finale",
    "today": "Aujourd'hui",
    "thisWeek": "Cette semaine",
    "last7Days": "Les 7 derniers jours",
    "thisMonth": "Mois en cours",
    "last30Days": "Les 30 derniers jours",
    "question": "Question",
    "createContactOnPartialSubmission": "Créer un contact lors de la soumission partielle",
    "howItWorks": "Comment ça fonctionne?",
    "createContactOnPartialSubmissionDescription": "Terminez la diapositive et cliquez sur « Suivant ». Un nouveau contact sera automatiquement créé et enregistré.",
    "swapWarningMessageSurvey": "La modification ou le changement d'options aura un impact sur ce champ personnalisé partout où le champ est utilisé. Cela peut également réinitialiser la logique conditionnelle. ",
    "swapWarningMessageForm": "La modification ou le changement d'options aura un impact sur ce champ personnalisé partout où le champ est utilisé. ",
    "migrationWarningMessage": "Cette fonctionnalité a été migrée vers la logique conditionnelle d’enquête.",
    "optionLabel": "Étiquette d'option",
    "calculationValue": "Valeur de calcul",
    "addOption": "Ajouter une option",
    "addOtherOption": "Ajouter l'option « Autre »",
    "otherOptionLabel": "Autre",
    "otherOptionPlaceholder": "Veuillez saisir une autre option ici.",
    "enableCalculations": "Activer les calculs",
    "allowOtherOption": "Autoriser une autre option",
    "productSelectionSubtext": "Individuel sur la sélection de plusieurs produits",
    "multi": "Plusieurs",
    "single": "Individuel",
    "productSelectionHeading": "Sélection du Produit",
    "spreadToColumns": "Répartir sur les colonnes",
    "columns": "Colonnes",
    "customstyle": "Style",
    "standard": "Norme",
    "bubble": "Bulle",
    "radioStyles": {
      "standardAlt": "Style radio standard",
      "bubbleAlt": "Style de bouton radio à bulles"
    },
    "integratePopup": {
      "title": "Intégrer le formulaire",
      "embedCode": "Code d'intégration",
      "useInFunnelOrEmbedCode": "Utilisation dans l'entonnoir / Code d'intégration",
      "iframeEmbed": "Embarquer Iframe",
      "layout": {
        "title": "Intégrer le type de mise en page",
        "description": "Sélectionnez une mise en page à intégrer dans un entonnoir ou un site Web externe",
        "allowMinimize": "Permettre de minimiser",
        "minimizedTitlePlaceholder": "Titre minimisé",
        "leftAlignAlt": "Aligner à gauche",
        "rightAlignAlt": "Alignement à droite"
      },
      "triggerType": "Type de déclencheur",
      "triggers": {
        "seconds": "secondes"
      },
      "activation": {
        "title": "Options d'activation",
        "visit": "visiter"
      },
      "deactivation": {
        "title": "Options de désactivation",
        "times": "fois"
      },
      "copyEmbedCode": "Copier le code d'intégration",
      "copyFormLink": "Copier le lien du formulaire",
      "openFormLink": "Lien pour le formulaire ouvert",
      "invalidInput": "Entrée non valide!",
      "funnel": {
        "funnel": "Entonnoir",
        "chooseStep": "Sélectionner une étape",
        "copyCodeAndOpenFunnel": "Copie le Code et Ouvert Entonnoir"
      },
      "share": {
        "share": "Partager",
        "shareViaSocials": "Partager via les Réseaux sociaux",
        "copyLink": "Copier le lien"
      },
      "email": {
        "email": "Courriel",
        "shareViaEmail": "Partager via Courriel",
        "emailButton": "Courriel",
        "blankTemplate": "Format d' Modèle",
        "emailMarketingTemplates": "Modèles de Marketing par Courriel",
        "or": "Ou",
        "chooseTemplate": "Sélectionnez parmi vos modèles",
        "continue": "Continuer"
      }
    },
    "rating": {
      "icon": "Icône",
      "iconAlignment": "Alignement des Icône",
      "count": "Nombre",
      "lowestRating": "Évaluation Min",
      "highestRating": "Évaluation Max",
      "iconSelectedState": "Icône État Sélectionné",
      "iconUnselectedState": "Icône de État non sélectionné",
      "rating": "Évaluation",
      "ratingSettings": "Réglages Évaluation",
      "calculationType": {
        "calculationType": "Comment Évaluation les domaines in des domaines personnalisés",
        "calculationTypeTooltip": "Quand vous enregistrez un message",
        "absolute": "Total",
        "percentage": "Pourcentage",
        "fraction": "Fraction"
      }
    },
    "desktopMode": "Mode bureau",
    "mobileMode": "Mode mobile",
    "versions": "Variantes",
    "advanced": "Avancé",
    "edit": "Modifier",
    "settings": "Réglages",
    "submissions": "Soumissions",
    "analytics": "Analyses",
    "notifications": "Notifications",
    "undo": "Annuler",
    "redo": "Refaire",
    "customValues": "Valeurs personnalisées",
    "pickBgFromImage": "Ajoute un flou à l'arrière-plan de votre boîte de messages. Si vous choisissez une couleur d'arrière-plan pour la boîte de message, elle apparaîtra par-dessus la boîte de message floutée.",
    "pickBgFromImageTip": "Choisit une couleur à contraste élevé pour l'image d'arrière-plan. Remarque : ne s'applique pas si l'arrière-plan du formulaire ne comporte pas d'image.",
    "messageBackgroundBlur": "Arrière-plan flouté",
    "confirmationMessage": "Message de confirmation",
    "deleteOption": "Supprimer l’option",
    "deleteConfirmationModal": {
      "defaultDescription": "Supprimer une option aura un impact sur ce Champ Voulez-vous vraiment le supprimer?",
      "validationMessage": "Veuillez saisir pour enregistrer.",
      "validationError": "Veuillez saisir Supprimer"
    },
    "disqualifyImmediately": "Disqualifier immédiatement",
    "disqualifyAfterSubmit": "Disqualifier après soumission",
    "generalSettings": "Réglages Général",
    "advancedSettings": "Réglages avancés",
    "customFieldName": "Nom de l'entreprise",
    "customFieldNameTooltip": "Ce nom d'entreprise est unique par .",
    "customFieldNameTooltipContact": "Ces champs permettent aux utilisateurs de saisir des informations supplémentaires sur une personne, telles que son type de prospect, sa date de naissance ou sa méthode de contact préférée.",
    "customFieldNameTooltipContactLearnMore": "En savoir plus",
    "customFieldNameTooltipOpportunity": "Ces champs sont utilisés pour suivre les données spécifiques à chaque opportunité, y compris des informations telles que le budget ou un objectif de clôture.",
    "customFieldNameTooltipOpportunityLearnMore": "En savoir plus",
    "customFieldNameTooltipCompany": "Ces champs permettent la capture d'informations au niveau de l'organisation (par exemple, pour les fournisseurs, les clients ou les agences) qui sont associés aux contacts.",
    "customFieldNameTooltipCompanyLearnMore": "En savoir plus",
    "customFieldNameTooltipCustomObject": "Ces champs permettent aux utilisateurs de recueillir des données spécifiques à l'entreprise, telles que des détails sur les actifs, les véhicules ou les propriétés, et d'intégrer ces informations dans leur système CRM.",
    "customFieldNameTooltipCustomObjectLearnMore": "En savoir plus",
    "uniqueKey": "Clé unique",
    "uniqueKeyTooltip": "Cette clé est l'identificateur système pour le champ personnalisé. Une fois défini, il ne peut plus être modifié.",
    "uniqueKeyTooltipLearnMore": "En savoir plus",
    "selectContactAssociation": "Sélectionner la relation avec des contacts",
    "selectObjectAssociation": "Sélectionner l’association entre {objectA} et {objectB}",
    "pickHowRecordsLink": "Les deux objets sont sur ce formulaire, donc la soumission doit savoir comment ils sont liés.",
    "association": "Relation",
    "newAssociationBetween": "Nouvelle association entre {objectA} et {objectB}",
    "opportunitySetupTitle": "Configurer cette opportunité",
    "opportunitySetupSubtitle": "Choisir où il mène.",
    "opportunitySetupSubtitleLinked": "Choisir où il mène, et comment il se lie à {object}.",
    "opportunityPlacement": "Placement de l'opportunité",
    "newPipeline": "Nouveau flux",
    "associations": "Associations",
    "createNewAssociation": "Créer une nouvelle relation",
    "selectAnAssociation": "Sélectionner une relation",
    "loadingAssociations": "Chargement des relations en cours…",
    "unknownAssociation": "Relation inconnue",
    "manyToMany": "Plusieurs à plusieurs",
    "failedToLoadAssociations": "Échec du chargement des relations",
    "noAssociationsFound": "Aucune relation trouvée",
    "keepThisField": "Garder ce champ",
    "customObject": "Objet personnalisé",
    "customObjects": "Objets personnalisés",
    "object": "Objet",
    "editAssociation": "Modifier la relation {objectName}",
    "editAssociationButton": "{edit} {association} {objectName}",
    "fields": "Domaines",
    "primaryFieldWarning": "{fieldName} est un champ principal pour {objectSingular} et est obligatoire pour créer une mise à jour d'un {objectSingular}.",
    "primaryFieldTitle": "{fieldName} est obligatoire pour créer ou mettre à jour l'enregistrement {objectSingular}.",
    "removeAllFields": "Supprimer tous les champs {objectSingular}",
    "customObjectsFallback": "Objets personnalisés",
    "noneAssociation": "Aucun",
    "noneAssociationDescription": "Aucune relation avec des contacts (aucun champ Contact présent)",
    "survey": {
      "layoutType": "Type de sondage",
      "oneQuestionPerPage": "Une question à la fois",
      "allQuestionsOnePage": "Plusieurs à la fois"
    },
    "quizQuestions": "Demande de quiz",
    "choiceElements": "Sélections des composants",
    "otherElements": "Autres composants",
    "listEditor": {
      "prefillValueHeader": "Pré-remplir la Valeur",
      "labelPlaceholder": "Étiquette",
      "valuePlaceholder": "Valeur",
      "optionRequiredError": "Le Champ d'options est obligatoire"
    },
    "field": "Champ",
    "scoreEditor": {
      "addFieldPlaceholder": "Ajouter un Champ",
      "fieldLabel": "Champ",
      "numberLabel": "nombre"
    },
    "fileUploadEditor": {
      "fileTypes": "Types de fichiers",
      "all": "Tout",
      "pdf": "PDF",
      "docxDoc": "D'UTILISATEUR",
      "png": "PNG",
      "gif": "GIF",
      "jpgJpeg": "JPG/JPG",
      "xlsCsv": "CSV",
      "fileAccess": "Accès aux fichiers",
      "fileAccessDescription": "Choisir qui peut accéder aux fichiers téléversés dans ce champ. Ce paramètre ne peut pas être modifié après la création du champ.",
      "fileAccessLocked": "Une fois le champ créé, son paramètre d'accès aux fichiers ne peut pas être modifié.",
      "privateFiles": "Fichiers privés",
      "privateFilesTooltip": "Seuls les utilisateurs autorisés peuvent consulter et télécharger des fichiers.",
      "publicFiles": "Fichiers publics",
      "publicFilesTooltip": "Toute personne ayant le lien du fichier peut consulter et télécharger des fichiers."
    },
    "ok": "OK",
    "allowMultipleFiles": "Autoriser plusieurs fichiers",
    "maxFileLimit": "Limite maximale de fichiers",
    "privacyPolicy": "Confidentialité",
    "termsOfService": "Terme de service",
    "colorPicker": {
      "brandColors": "Couleurs de la marque",
      "defaultColors": "Couleurs par défaut",
      "globalCustomColors": "Couleurs personnalisées mondiales"
    },
    "billingFrequency": "Fréquence de facturation",
    "otherAmount": "Autre montant",
    "exampleUrlPlaceholder": "https://www.exemple.com",
    "checkboxStyles": {
      "standardAlt": "Style standard de case à cocher",
      "bubbleAlt": "Style de case à cocher à bulles"
    },
    "previewIcons": {
      "exportAlt": "Icône d’exportation",
      "shipmentAlt": "Icône d’expédition",
      "resultAlt": "Icône de la page de résultats"
    },
    "examples": {
      "sampleUrl": "https://exemple.com"
    },
    "showing": "Affichage",
    "of": "de",
    "enterCouponCode": "Entrez le code promo",
    "apply": "Applique",
    "paymentWillBeProcessed": "Le paiement sera traité dès que vous passerez à l'étape suivante",
    "paymentWillBeProcessedNextSlide": "Le paiement sera traité dès que l'utilisateur passera à la diapositive suivante",
    "showThisAlertToUsers": "Affichez cette alerte aux utilisateurs",
    "sixteenDigitCardNumber": "Numéro de carte à 16 chiffres",
    "mmYy": "MM / AA",
    "cvc": "CVC",
    "threeDigitCode": "Code à trois chiffres",
    "enterCardNumber": "Entrez le numéro de carte",
    "pleaseFillRequiredFields": "Veuillez remplir tous les champs obligatoires !",
    "opportunitySettingsIncomplete": "Paramètres d'opportunité incomplets",
    "opportunitySettingsIncompleteDescription": "Ce formulaire inclut les champs d’opportunité, mais les paramètres d’opportunité n’ont pas été mis à jour. Veuillez configurer les paramètres de l'opportunité pour pouvoir sauvegarder le formulaire.",
    "ariaAttributes": {
      "iconSearch": "Recherche d'icônes"
    },
    "alt": {
      "standardRadioStyle": "Style radio standard",
      "bubbleRadioStyle": "Style radio à bulles"
    },
    "value": "Valeur",
    "jumpTo": "Aller à",
    "thankYouJohnDoe": "Merci, John Doe",
    "total": "Total",
    "urlExamples": {
      "simple": "exemple.com",
      "https": "https://exemple.com",
      "withPath": "example.com/path",
      "fullPath": "https://www.example.com/path"
    },
    "quizThankYou": "Merci d'avoir pris le temps de compléter ce questionnaire."
  },
  "overallScore": {
    "defaultTitle": "Score général"
  },
  "fields": {
    "quizQuestions": {
      "singleChoice": "Sélection individuelle",
      "multipleChoice": "Sélection multiples de choix",
      "yesNo": "Oui / Non",
      "shortAnswer": "Réponse à la Cour",
      "longAnswer": "Longueur de la réponse",
      "number": "nombre",
      "singleDropdown": "Liste individuelle",
      "multiDropdown": "Plusieurs Liste déroulante"
    },
    "personal": {
      "fullName": "Nom Plein",
      "firstName": "Prénom",
      "lastName": "Nom de famille",
      "dateOfBirth": "Date de naissance",
      "phone": "Téléphone",
      "email": "Courriel",
      "fullNamePlaceholder": "Saisissez votre nom complet",
      "firstNamePlaceholder": "Saisissez votre prénom",
      "lastNamePlaceholder": "Saisissez votre nom de famille",
      "dateOfBirthPlaceholder": "JJ / MM / AAAA",
      "phonePlaceholder": "+1 (555) 000-0000"
    },
    "submit": {
      "button": "Bouton"
    },
    "integration": {
      "sellProducts": "Vendre des produits",
      "collectPayment": "Percevoir le Paiement"
    },
    "address": {
      "address": "Adresse",
      "streetAddress": "Adresse de la rue",
      "city": "Ville",
      "state": "État",
      "country": "Pays",
      "postalCode": "Code postal",
      "organization": "Groupe",
      "website": "Site Web",
      "websitePlaceholder": "https://yourwebsite.com",
      "addressPlaceholder": "Adresse municipale",
      "streetAddressPlaceholder": "Saisissez votre adresse complète",
      "cityPlaceholder": "Saisissez votre ville",
      "statePlaceholder": "Saisissez votre État",
      "countryPlaceholder": "Saisissez votre pays",
      "postalCodePlaceholder": "Code postal",
      "organizationPlaceholder": "Saisissez le nom de l'organisation"
    },
    "text": {
      "singleLine": "Ligne individuelle",
      "multiLine": "Plusieurs Ligne",
      "textBoxList": "Liste des zones de texte",
      "singleLinePlaceholder": "Saisissez votre texte",
      "multiLinePlaceholder": "Taper votre message ici"
    },
    "choiceElements": {
      "singleDropdown": "Liste individuelle",
      "multiDropdown": "Plusieurs Liste déroulante",
      "checkbox": "Case à cocher",
      "radio": "Radio",
      "singleDropdownPlaceholder": "Sélectionnez une option",
      "multiDropdownPlaceholder": "Veuillez choisir une ou plusieurs options",
      "pictureChoice": {
        "label": "Choix de l'image",
        "multipleSelection": "Sélection multiple",
        "selectionTypeLocked": "Le type de sélection ne peut pas être modifié une fois que ce champ personnalisé a été enregistré.",
        "imageRequiredBeforeSave": "Chaque option dans un élément de Choix de l'image doit avoir une image.",
        "labelRequiredBeforeSave": "Chaque option dans un élément de choix d'image doit avoir une étiquette.",
        "duplicateOptionLabelsBeforeSave": "Chaque option dans un élément de choix d'image doit avoir une étiquette unique.",
        "selectionLimitInvalidBeforeSave": "Veuillez saisir une limite de sélection valide pour l'élément Choix de l'image.",
        "selectionLimit": "Limite de sélection",
        "unlimited": "Illimitée",
        "exact": "Exacte",
        "range": "Plage",
        "exactSelections": "Sélections exactes",
        "minimum": "Minimum",
        "maximum": "Maximum",
        "options": "Options",
        "optionSettings": "Paramètres d'options",
        "showOptionLabel": "Afficher l'étiquette de l'option",
        "addOption": "Ajouter une option",
        "otherOption": "Autre option",
        "imageFit": "Ajustement de l'image",
        "cover": "Couverture",
        "contain": "Contenir",
        "fill": "Remplir",
        "spreadToColumns": "Répartir sur les colonnes",
        "columns": "Colonnes",
        "numberOfColumns": "Nombre de colonnes",
        "desktopColumnsLimit": "Maximum de {count} colonnes sur ordinateur.",
        "mobileColumnsLimit": "Maximum de {count} colonnes sur mobile.",
        "otherOptionLabel": "Autre étiquette d'option",
        "optionLabel": "Étiquette d'option",
        "image": "Image",
        "media": "Médias",
        "otherImageUploadUnavailable": "Une image ne peut pas être téléversée pour l’option Autre.",
        "removeImage": "Supprimer l'image",
        "deleteOption": "Option de suppression",
        "altText": "Texte alternatif"
      }
    },
    "customized": {
      "text": "Texte",
      "html": "HTML",
      "htmlPlaceholder": "Placez le code HTML Personnalisé ici.",
      "captcha": "Majuscule",
      "captchaDefaultLabel": "Défi",
      "botProtection": "Protection contre les bots",
      "verificationMode": "Mode de vérification",
      "interactive": "Interactif",
      "invisible": "Invisible",
      "invisibleModeDescription": "Cette vérification s'exécute automatiquement en arrière-plan et ne sera pas visible pour les utilisateurs",
      "fieldHiddenWarning": "Ce champ est masqué et ne sera pas visible sur le formulaire.",
      "verifyHuman": "Vérifiez que vous êtes un humain",
      "privacy": "Confidentialité",
      "help": "Aide",
      "captchaPlaceholder": "CAPTCHA",
      "source": "Source",
      "termsAndConditions": "T et C",
      "termsAndConditionsPlaceholder": "J'accepte les conditions générales via l'entreprise. via l'envoi de mon",
      "score": "Pointage",
      "scorePlaceholder": "Ex : Votre score est de 100 %"
    },
    "other": {
      "url": "URL",
      "urlPlaceholder": "Saisissez l'URL",
      "image": "Image",
      "fileUpload": "Téléverser du Fichier",
      "monetary": "Monétaire",
      "number": "nombre",
      "datePicker": "Date et heure",
      "datePickerLegacy": "Sélecteur de date",
      "datePickerGeneratedName": "Date",
      "timePickerGeneratedName": "Heure",
      "dateTimePickerGeneratedName": "Date et heure",
      "signature": "Signataire",
      "monetaryPlaceholder": "Saisissez le montant",
      "signaturePlaceholder": "Veuillez signer ici",
      "numberPlaceholder": "Saisissez un numéro",
      "datePickerPlaceholder": "JJ / MM / AAAA",
      "imageUploadPlaceholder": "Aucune image ajoutée pour le moment",
      "imageUploadSubText": "Téléversez sur Media Storage ou glissez-déposez",
      "imageUploadButtonText": "Téléverser une image",
      "fileText": "Fichier",
      "fileUploadSupportedFileTypes": "PDF, DOC/DOCX, XLS/CSV, JPG/JPEG, PNG, GIF",
      "fileUploadPlaceholder": "Cliquez pour télécharger"
    },
    "customstyle": "Style",
    "standard": "Norme",
    "bubble": "Bulle"
  },
  "survey": {
    "addSlideText": "Ajouter des éléments",
    "defaultScreenTitle": "Glissez-déposez les composants",
    "defaultScreenDescription": "Déplacez votre question vers la page {pageIndex} en utilisant les éléments à gauche.",
    "typeOfBuilder": "Enquête",
    "survyeStyle": "Style d'enquête",
    "surveyName": "Nom de l'enquête",
    "surveyElement": "Élément de l'enquête",
    "addSurveyElement": "Ajouter un élément d'enquête",
    "cloneSlide": "Dupliquer la diapositive",
    "unsavedAlertMessage": "L'enquête comporte un travail non enregistré. Voulez-vous vraiment quitter et perdre tout travail non enregistré?",
    "thirdPartyScriptAlertMessage": "Les scripts tiers placés dans le bloc HTML peuvent offrir des fonctionnalités puissantes, mais ils présentent également des risques pour la confidentialité, la sécurité, les performances et le comportement de la page. Par conséquent, nous vous recommandons de vérifier le contenu de ce script avant de l'enregistrer dans l'enquête.",
    "integrateHeader": "Intégrer le sondage",
    "integrateSubHeader": "Utilisez les options suivantes pour intégrer votre enquête personnalisée dans votre site Web.",
    "integrateCopyLinkMessage": "Copiez le lien ci-dessous et partagez-la facilement à l'endroit souhaité.",
    "onSurveySubmission": "Lors de la soumission de l'enquête",
    "saveExitConfirmation": "Sauvegarder la progression des sondages",
    "surveySettings": "Paramètres de l'enquête",
    "oneQuestionAtTime": "Une question à la fois",
    "backButton": "Bouton Retour",
    "backButtonTooltipMessage": "Le bouton Retour aidera les utilisateurs à revenir à la diapositive précédente",
    "disableAutoNavigation": "Désactiver la navigation automatique",
    "disableAutoNavigationTooltipMessage": "Naviguez automatiquement vers les .",
    "autoNavigation": "Navigation Auto",
    "autoNavigationTooltipMessage": "Naviguez automatiquement vers les .",
    "progressBar": "Barre de progression",
    "progressBarTooltipMessage": "Désactiver cette option supprimera la barre de progression du sondage",
    "disableAnimation": "Désactiver l'animation",
    "disableAnimationTooltipMessage": "Si vous activez cette option, l'animation de transition entre diapositives sera désactivée.",
    "scrollToTop": "Faire défiler jusqu'en haut",
    "scrollToTopTooltipMessage": "Si vous activez cette fonction, l'enquête défilera vers le haut de la diapositive suivante.",
    "submitSurvey": "Soumettre le sondage",
    "disqualifyImmediately": "Disqualifier immédiatement",
    "disqualifyAfterSubmit": "Disqualifier après soumission",
    "disqualifyAfterSubmitLowerCase": "Disqualifier après soumission",
    "footerHTML": "HTML de pied de page",
    "footerHTMLMessage": "Vous pouvez écrire des feuilles de style personnalisées (en utilisant la balise de style) et du HTML dans la même case.",
    "editFooter": "Modifier le pied de page",
    "disqualifySettings": "Paramètres de disqualification",
    "disqualifyImmediatelyLabel": "Immédiatement",
    "disqualifyAfterSubmitLabel": "Après la soumission",
    "slideConflictAlertMessage": "Cette diapositive contient plusieurs questions qui ont une logique définie. Cela peut entraîner des comportements non intentionnels.",
    "addSlide": "Ajouter une diapositive",
    "settings": "Paramètres",
    "delete": "Supprimer",
    "slideDeleteAlertMessage": "Voulez-vous vraiment supprimer cette diapositive?",
    "slideDeleteBetweenAlertMessage": "Cela réorganisera les autres diapositives. Voulez-vous vraiment supprimer cette diapositive?",
    "slideLabel": "Diapositive {n}",
    "slideName": "Nom de la diapositive",
    "slidePosition": "Position de la diapositive",
    "jumpTo": "Aller à",
    "jumpToSubText": "Accéder à une diapositive spécifique",
    "enableTimezoneSurvey": "Si vous activez cette option, l'information de fuseau horaire de la personne qui soumet l'enquête sera capturée.",
    "footer": {
      "footer": "Pied de page",
      "enableNewFooter": "Activer le nouveau pied de page",
      "stickToSurvey": " Joindre à l'enquête",
      "backgroundFill": "Remplissage d’arrière-plan",
      "footerHeight": "Hauteur du pied de page",
      "enableProgressBar": "Activer la barre de progression",
      "buttons": "Boutons",
      "button": "Bouton",
      "buttonType": "Type de bouton",
      "buttonTypeTooltip": "Choisissez comment les boutons de navigation s'affichent dans le pied de page de votre sondage",
      "fillNext": "Remplir (suivant)",
      "fillPrevious": "Remplir (précédent)",
      "fillSubmit": "Remplissage (Soumettre)",
      "textColor": "Texte du bouton",
      "position": "Position",
      "positionTooltip": "Choisissez comment les boutons de navigation s'affichent dans le pied de page de votre sondage",
      "previousText": "Précédent (texte)",
      "nextText": "Suivant (texte)",
      "submitText": "Soumettre (texte)",
      "fillComplete": "Remplissage terminé",
      "fillInactive": "Remplissage inactif",
      "footerType": "Type de pied de page",
      "stickToCard": "Joindre à la carte",
      "stickToPage": "Joindre à la page",
      "stepTextColor": "Étape de la couleur du corps",
      "progressBarFill": "Remplir de la Barre de progression",
      "progressBarInactive": "Barre de progression Inactif",
      "arrowFill": "Remplir de la Flèche",
      "submitColorMobile": "Soumettre (Couleur)",
      "arrowFillColor": "Couleur de la couleur",
      "buttonTypes": {
        "textAndArrow": "Texte & Flèche",
        "onlyText": "Texte seulement",
        "onlyArrow": "Flèche uniquement"
      },
      "positions": {
        "leftAndRight": "Gauche et droite"
      },
      "placeholders": {
        "prev": "Précédent",
        "next": "Suivant",
        "submit": "Soumettre"
      }
    },
    "surveyNotfication": "Notification d’enquête",
    "style": {
      "surveyPadding": "Remplissage de l'enquête"
    },
    "integratePopup": {
      "shareOrEmbed": "Intégrer ou partager une enquête",
      "share": {
        "openFormLink": "Ouvert le Lien de Sondage"
      },
      "email": {
        "emailSubheader": "Créez un courriel vide et intégration de votre Sondage, sortant un modèle et l'intégration immédiatement."
      }
    },
    "autoResponderSubheader": "Envoyez un courriel automatisé à la personne qui soumet l'enquête (le courriel comprend une copie des renseignements saisis dans l'enquête).",
    "sendSubmissionsAsPdf": "Envoyer la soumission de sondage sous forme de PDF",
    "switchToOneQuestionAtTimeOn": "L'activation d' « Une Question à une Date» bloque votre logique conditionnelle actuelle.",
    "switchToOneQuestionAtTimeOff": "Désactiver « Une Question à une Date» a un impact sur votre logique conditionnelle Config",
    "switchToOneQuestionAtTimeOnWarning": "Certains conditions ne fonctionneront plus comme Date.",
    "switchToOneQuestionAtTimeOffWarning": " Toutes les conditions conçue pour le Débit sur des questions cesseront de fonctionner comme prévu.",
    "createContactOnPartialSubmissionSubText": "Crée un contact lorsqu'un utilisateur clique sur « Suivant » sur n'importe quelle diapositive — même s'il ne termine pas le sondage.",
    "dragDrop": {
      "imageLabel": "Image {n}",
      "htmlLabel": "HTML {n}",
      "defaultFolderName": "Sondage {'|'} {name}",
      "defaultTermsHtml": "<p style=\"text-align: center\"><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Politique de confidentialité</a> | <a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Conditions d'utilisation</a></p>",
      "smsConsent": "Je consens à recevoir des notifications par SMS, des alertes et des communications marketing occasionnelles de la part de l’entreprise. La fréquence des messages varie. Les frais de message et de données peuvent s'appliquer. Envoyez HELP au (XXX) XXX-XXXX pour obtenir de l’assistance. Vous pouvez répondre STOP pour vous désabonner à tout moment."
    }
  },
  "form": {
    "typeOfBuilder": "Formulaire",
    "formStyle": "Style de formulaire",
    "formElement": "Élément de formulaire",
    "addFormElement": "Ajouter un élément de formulaire",
    "addConditionalLogic": "Ajouter une logique conditionnelle",
    "openConditionalLogic": "Ouvrir la logique conditionnelle",
    "inlineForm": "Formulaire en ligne",
    "formName": "Nom du formulaire",
    "fullScreenMode": "Mode plein écran",
    "fullScreenModetooltip": "Si vous activez cette fonction, le formulaire s'étendra sur toute la largeur de son conteneur, s'étirant jusqu'au bord de la zone d'intégration tout en adhérant à la largeur du formulaire.",
    "enableTimezoneForm": "Si vous activez cette option, l'information de fuseau horaire de la personne qui soumet le formulaire sera capturée.",
    "formSettings": "Paramètres du formulaire",
    "scheduleVisibility": {
      "title": "Planifier la visibilité de {product}",
      "subtitle": "Définissez quand ce {product} doit commencer et cesser d'accepter les réponses. En dehors de cette fenêtre, les visiteurs verront les messages que vous configurez ci-dessous.",
      "formOpens": "{Product} s'ouvre",
      "formCloses": "{Product} se ferme",
      "rightAway": "Immédiatement",
      "never": "Jamais",
      "pickADate": "Choisir une date",
      "opensPlaceholder": "S'ouvre dès que vous publiez",
      "closesPlaceholder": "Reste ouvert jusqu'à ce que vous le fermiez",
      "date": "Date",
      "time": "Heure",
      "timezone": "Fuseau horaire",
      "timezoneHelp": "S'applique à la fois aux heures d'ouverture et de fermeture.",
      "timezonePlaceholder": "Sélectionnez un fuseau horaire",
      "timeline": {
        "notOpenYet": "Pas encore ouvert",
        "acceptingResponses": "Acceptation des réponses",
        "closed": "Fermé",
        "current": "Actuel",
        "opens": "Ouvre",
        "closes": "Ferme"
      },
      "whatVisitorsSee": "Ce que voient les visiteurs",
      "whatVisitorsSeeHelp": "Ces pages ne s'affichent qu'en dehors de la fenêtre ouverte. Sélectionnez un état pour le configurer.",
      "states": {
        "beforeTitle": "Avant l'ouverture du {product}",
        "afterTitle": "Après la fermeture du {product}",
        "showsPage": "Affichage d’une page personnalisée",
        "redirectsTo": "Redirige vers {url}"
      },
      "showPage": "Afficher une page",
      "showPageHelp": "Concevez ce que les visiteurs voient.",
      "openLink": "Ouvrir un lien",
      "openLinkHelp": "Envoyez-les vers une autre URL.",
      "redirectUrl": "URL de redirection",
      "redirectUrlPlaceholder": "https://example.com",
      "redirectUrlHelp": "Les visiteurs dans cet état sont envoyés ici au lieu de voir une page. Utilisez une URL complète telle que https://example.com/path.",
      "redirectUrlInvalid": "Veuillez entrer une URL valide commençant par http:// ou https://, comme https://example.com/path.",
      "defaultBeforeMessage": "Ce {product} n'est pas encore ouvert.",
      "defaultAfterMessage": "Ce {product} est maintenant fermé.",
      "defaultBeforeBody": "Ce {product} n'accepte pas encore de réponses. Veuillez vérifier de nouveau une fois qu'il sera ouvert pour soumettre votre réponse.",
      "defaultAfterBody": "Merci de votre intérêt! Ce {product} n'accepte plus de réponses. Veuillez contacter le propriétaire de {product} si vous avez encore besoin de le joindre.",
      "closeAfterOpenError": "L'heure de fermeture doit être postérieure à l'heure d'ouverture.",
      "preview": {
        "label": "Aperçu",
        "labelHint": "— comment les visiteurs le voient",
        "redirectTo": "Vous serez redirigé vers :",
        "poweredBy": "Propulsé par votre agence"
      },
      "appearance": {
        "title": "Apparence",
        "cardBackground": "Arrière-plan de carte",
        "pageBackground": "Arrière-plan de la page",
        "cornerRadius": "Rayon d'angle",
        "cardWidth": "Largeur de carte",
        "cardHeight": "Hauteur de la carte",
        "shadow": "Ombre",
        "autoPlaceholder": "Auto",
        "marginPadding": "Marge et remplissage",
        "auto": "auto",
        "miscellaneous": "Divers",
        "agencyBranding": "Image de marque de l’agence",
        "agencyBrandingHelp": "Affichez le logo et le nom de votre agence sur les pages à l'état fermé.",
        "shadowOptions": {
          "none": "Aucun",
          "soft": "Doux",
          "elevated": "Élevé"
        },
        "colors": {
          "default": "Par défaut",
          "lightGray": "Gris clair",
          "brandTint": "Teinte de la marque",
          "blush": "Fard à joues",
          "dark": "Sombre",
          "white": "Blanc",
          "coolGray": "Gris froid"
        }
      }
    },
    "saveExitConfirmation": "Enregistrez la progression des formulaires",
    "unsavedAlertMessage": "Le formulaire comporte un travail non enregistré. Voulez-vous vraiment quitter et perdre tout travail non enregistré?",
    "thirdPartyScriptAlertMessage": "Les scripts tiers placés dans le bloc HTML peuvent offrir des fonctionnalités puissantes, mais ils présentent également des risques pour la confidentialité, la sécurité, les performances et le comportement de la page. Par conséquent, nous vous recommandons de vérifier le contenu de ce script avant de l'enregistrer dans le formulaire.",
    "onFormSubmission": "Lors de la soumission du formulaire",
    "integrateForm": "Intégrer le formulaire",
    "embedlayoutType": "Embarquer le Type de Mise en page",
    "embedlayoutTypeSubMessage": "Sélectionnez une mise en page à intégrer dans un entonnoir ou un site Web externe.",
    "triggerType": "Type de déclencheur",
    "showOnScrolling": "Afficher lors du défilement",
    "showAfter": "Afficher après",
    "seconds": "secondes",
    "alwaysShow": "Toujours afficher",
    "activationOptions": "Options d'activation",
    "activateOn": "Activer lors de",
    "visit": "visite",
    "alwaysActivated": "Toujours activé",
    "deactivationOptions": "Options de désactivation",
    "deactivateAfterShowing": "Désactiver après affichage",
    "times": "fois",
    "deactiveOnceLeadCollected": "Désactiver une fois le client potentiel collecté",
    "neverDeactivate": "Ne jamais désactiver",
    "copyEmbedCode": "Copier le code d'intégration",
    "copyFormLink": "Copier le lien du formulaire",
    "openFormLink": "Ouvrir le lien du formulaire",
    "inline": "Intégré",
    "inlineDescription": "Un formulaire intégré apparaît avec le contenu de la page en tant qu'élément d'origine. Il ne se superpose pas et ne peut pas être fermé ou réduit au minimum.",
    "inlineHoverDescription": "Un formulaire intégré apparaît avec le contenu de la page en tant qu'élément d'origine. Il ne se superpose pas et ne peut pas être fermé ou réduit au minimum.",
    "popup": "Fenêtre contextuelle",
    "popupDescription": "Une fenêtre contextuelle affiche le formulaire sous la forme d'une superposition à l'intérieur d'une case lumineuse. Cette dernière ne peut pas être réduite, mais peut être fermée.",
    "popupHoverDescription": "Une fenêtre contextuelle affiche le formulaire sous la forme d'une superposition à l'intérieur d'une case lumineuse. Cette dernière ne peut pas être réduite, mais peut être fermée.",
    "politeSlideIn": "Formulaire coulissant",
    "politeSlideInDescription": "Un formulaire coulissant apparaît en bas de l'écran et disparaît une fois fermé.",
    "politeSlideInHoverDescription": "Apparaît en bas de l'écran et disparaît une fois fermé.",
    "stickySidebar": "Barre latérale épinglée",
    "stickySidebarDescription": "Une barre latérale épinglée apparaît sur le côté de l'écran et peut être réduite à un onglet épinglé sur le côté de la fenêtre.",
    "stickySidebarHoverDescription": "Apparaît sur le côté de l'écran et peut être réduite à un onglet épinglé sur le côté de la fenêtre.",
    "allowMinimize": "Permettre de réduire",
    "checkForCookieConsent": "Respecter le consentement aux témoins du site hôte",
    "checkForCookieConsentTooltip": "Les événements du pixel ne se déclenchent qu'après l'acceptation des témoins de marketing par le visiteur du site où ce formulaire est intégré. La détection automatique recherche GHL-CookieConsent, OneTrust, Cookiebot, Complianz, Usercentrics, TrustArc, Cookieyes, Iubenda, Termly, Osano, Didomi et IAB TCF.",
    "cookieConsentProvider": "Fournisseur de consentement aux témoins",
    "cookieConsentProviderPlaceholder": "Sélectionner votre bannière de consentement aux témoins",
    "cookieConsentProviderAutoDetect": "Détecter automatiquement",
    "modalHeight": "Hauteur de la fenêtre contextuelle",
    "modalHeightPlaceholder": "Entrez la hauteur de la fenêtre contextuelle",
    "conditonalLogic": {
      "conditions": "Conditions",
      "noExistingCondition": "Aucune condition existante pour le moment",
      "freeRoamMessage": "Vous êtes libre de vous déplacer sans règles, du moins pour l'instant.",
      "addNewCondition": "Ajouter une nouvelle condition",
      "redirectToUrl": "Rediriger vers une URL",
      "displayCustomMessage": "Afficher un message personnalisé",
      "disqualifyLead": "Disqualifier le prospect",
      "showHideFields": "Afficher/Masquer les champs",
      "jumpTo": "Accéder à",
      "redirectToUrlSubText": "Rediriger la soumission d'utilisateurs",
      "displayCustomMessageSubText": "Afficher les messages en fonction des entrées de l'utilisateur",
      "disqualifyLeadSubText": "Filtre les entrées dans des conditions spécifiques",
      "showHideFieldsSubText": "Modifier la Visibilité",
      "openBelowUrl": "Ouvrir l'URL ci-dessous",
      "showCustomMessage": "Afficher un message personnalisé",
      "alertConditionDelete": "Voulez-vous vraiment supprimer cette condition?",
      "deleteCondition": "Supprimer la condition",
      "conditionExecutedMessage": "Les conditions seront exécutées de haut en bas.",
      "anyVariant": "Toute variante",
      "bumpSuffix": "Renvoi d'une commande",
      "untitledProduct": "Produit sans titre",
      "deletedProduct": "Produit supprimé",
      "deletedVariant": "Variante supprimée",
      "allOperationOptions": {
        "isEqualTo": "Est égal à",
        "isNotEqualTo": "N'est pas égal à",
        "contains": "Contient",
        "doesNotContain": "Ne contient pas",
        "startsWith": "Commence par",
        "endsWith": "Se termine par",
        "isEmpty": "Est vide",
        "isFilled": "Est rempli",
        "before": "Avant",
        "after": "Après",
        "greaterThan": "Supérieur à",
        "lessThan": "Inférieur à",
        "between": "Entre",
        "isChecked": "Est vérifié",
        "isNotChecked": "N’est pas vérifié",
        "isSelected": "Est sélectionné",
        "isNotSelected": "N'est pas sélectionné",
        "pricingOptionIs": "L'option de tarification est",
        "pricingOptionIsNot": "L'option de tarification n'est pas"
      },
      "logic": {
        "if": "Si",
        "then": "Puis",
        "and": "Et",
        "or": "Ou"
      },
      "phoneAlertMessage": "Pour rechercher des numéros de téléphone avec un code de pays, vous devez inclure explicitement le symbole « + » dans votre requête de recherche.",
      "deleteAlertMessage": "Voulez-vous vraiment supprimer ce champ? La condition associée à ce champ sera également supprimée.",
      "deleteField": "Supprimer le champ",
      "jumpToDescription": "Accédez à une diapositive spécifique lorsque les conditions sont remplies",
      "cycleError": "Impossible d’enregistrer. Cycle détecté entre {a} et {b}",
      "jumpToSlide": "Accéder à une diapositive",
      "submitSurvey": "Soumettre un sondage",
      "pageTitle": "P{index} - {title}",
      "selectSlideToJumpTo": "Sélectionnez la diapositive à partir de laquelle vous souhaitez passer",
      "selectedSlide": "Diapositive sélectionnée",
      "typeValueHere": "Veuillez saisir une valeur ici",
      "field": "Champ",
      "slide": "Diapositive",
      "selectFieldOrSlide": "Sélectionner le champ ou la diapositive",
      "selectFieldState": "Sélectionner l'état du champ",
      "selectField": "Sélectionnez le champ",
      "quizFields": "Champs du questionnaire",
      "standardFields": "Champs standard",
      "highestScore": "Score le plus élevé",
      "lowestScore": "Score le plus bas",
      "overallScore": "Score global",
      "categoryScore": "Score de catégorie",
      "selectCategory": "Sélectionner une catégorie",
      "scoreFormat": "Format du score",
      "percentage": "Pourcentage",
      "actualScore": "Score réel",
      "outOf10": "Sur 10",
      "selectOption": "Sélectionner l’option",
      "jumpToTarget": "Aller à",
      "jumpToQuestion": "Passer à la question",
      "chooseQuestion": "Sélectionner une question",
      "includeStart": "Inclure le début",
      "includeEnd": "Inclure la fin",
      "includeValue": "Inclure {value}",
      "hideField": "Masquer le champ",
      "hideFields": "Masquer les champs",
      "showField": "Afficher le champ",
      "showFields": "Afficher les champs",
      "additionalRulesPrefix": "... et",
      "additionalRulesSuffix": "autres règles {ifLabel}...",
      "shownTargetsWithMore": "{shown}, +{count} de plus",
      "noConditionsAlt": "Aucune condition pour le moment",
      "outcomeLabels": {
        "show": "Afficher",
        "jumpTo": "Aller à"
      },
      "entireSection": "Toute la section",
      "specificProducts": "Produits spécifiques",
      "mainProduct": "Produit principal",
      "bumpProduct": "Produit additionnel",
      "searchProductsOrVariants": "Rechercher des produits ou des variantes",
      "selectAll": "Sélectionner tout",
      "clear": "Effacer",
      "variantsCount": "{count} variantes",
      "productsSelectedCount": "{selected} sur {total} produits",
      "selectAtLeastOneProduct": "Sélectionnez au moins 1 produit ou variante.",
      "productHint": {
        "entireHide": "Toute la section {section} est masquée si la condition est remplie.",
        "entireShow": "Toute la section {section} reste masquée jusqu'à ce que la condition soit remplie.",
        "specificHide": "Les éléments sélectionnés sont masqués si la condition est remplie.",
        "specificShow": "Les éléments sélectionnés restent masqués jusqu'à ce que la condition soit remplie.",
        "allSelectedHide": "Puisque tous les produits sont sélectionnés, toute la section sera masquée.",
        "allSelectedShow": "Puisque tous les produits sont sélectionnés, toute la section reste masquée jusqu'à ce que la condition soit remplie."
      },
      "productsCountShort": "{count} produits",
      "noProductsMatchSearch": "Aucun produit ne correspond à cette recherche.",
      "noProductsTitle": "Aucun produit dans ce champ pour l'instant",
      "noProductsBody": "Ajoutez des produits à {section} pour les afficher ou les masquer un à la fois. Vous pouvez quand même masquer toute la section.",
      "remove": "Supprimer",
      "deletedProductTitleOne": "1 produit n'existe plus",
      "deletedProductTitleOther": "{count} produits n'existent plus",
      "deletedProductBodyOne": "Un produit sélectionné a été supprimé de {section}. Supprimez-le de cette condition pour enregistrer.",
      "deletedProductBodyOther": "Les produits sélectionnés ont été supprimés de {section}. Supprimez-les de cette condition pour enregistrer.",
      "selectPricingOption": "Sélectionner une option de tarification",
      "selectProduct": "Sélectionner un produit"
    },
    "minimizedTitlePlaceholder": "Titre réduit",
    "dragYourElementFromLeft": "Faites glisser vos éléments ici à partir de la gauche.",
    "formNotification": "Notification de formulaire",
    "sendSubmissionsAsPdf": "Envoyer la soumission de formulaire sous forme de PDF",
    "style": {
      "formPadding": "Remplissage de formulaire"
    },
    "integratePopup": {
      "shareOrEmbed": "Intégrer ou Partager le Formulaire",
      "share": {
        "openFormLink": "Ouvert le Lien du Formulaire"
      },
      "email": {
        "emailSubheader": "Créez un courriel vide et equerrez votre formulaire, ou ."
      }
    },
    "choosePosition": "Sélectionner du statut",
    "testBuild": "Version d'essai"
  },
  "quiz": {
    "quizElement": "Élément de quiz",
    "quizNotification": "Notification de questionnaire",
    "viewAndCustomise": "Voir et personnaliser",
    "categoryAndScore": "Catégorie et score",
    "provideFeedback": "Fournir des commentaires",
    "addQuizElement": "Ajouter un élément de quiz",
    "typeOfBuilder": "Questionnaire",
    "addQuestions": "Ajouter des questions",
    "dragAndDropQuestion": "Traîner et supprimer un élément de Question ici.",
    "addNewPage": "Ajouter une Page",
    "editTemplate": "Modifier le Modèle",
    "editResultPage": "Modifier la page de résultats",
    "clonePage": "Dupliquer la page",
    "category": {
      "category": "Catégorie",
      "useCategoryWhen": "Utiliser des catégories Quand",
      "manageCategories": "Gérer les Catégories",
      "howItWorks2": "Comment fonctionne ce travail",
      "addCategoryMessage": "Ajouter une nouvelle catégorie",
      "assignCategoryMessage": "Attribuer une catégorie à tous les options",
      "editResultsMessage": "Afficher le score in la Page des résultats",
      "toEvaluateTheResponder": "Pour Comparer le Répondeur en fonction de plusieurs facteurs",
      "showMultipleCategoryScore": "Afficher plusieurs catégories in la Page des résultats",
      "displayVaryingContent": "Affichage de la Page de résultats en fonction de l'affichage du niveau de score",
      "addManage": "Ajouter / Gérer",
      "carouselAlt": "Diapositive d’aperçu de la Catégorie"
    },
    "quizSettings": "Paramètres du quiz",
    "saveExitConfirmation": "Enregistrez la progression des quiz",
    "onQuizSubmission": "Lors de la soumission du questionnaire",
    "settings": "Paramètres",
    "deletePage": "Supprimer la page",
    "quizResult": {
      "resultTemplate": "Modèle de page de résultats",
      "quizResultAlertMessage": "La page de résultats choisie s'affichera une fois le questionnaire terminé",
      "overallScoreLabel": "Note globale",
      "resultTemplateAlt": "Aperçu du modèle de résultats du quiz"
    },
    "deleteSlideMessage": "Voulez-vous vraiment supprimer cette diapositive?",
    "autoResponderSubheader": "Envoyez un courriel automatisé à la personne qui soumet le questionnaire (le courriel comprend une copie des renseignements qu’elle a saisis dans le questionnaire).",
    "sendSubmissionsAsPdf": "Envoyer la soumission du questionnaire sous forme de PDF",
    "sendQuizResultsAsPdf": "Envoyer le résultat du questionnaire sous forme de PDF",
    "integrateHeader": "Intégrer le quiz",
    "integrateSubHeader": "Utilisez les options suivantes pour intégrer votre questionnaire personnalisé dans votre site Web.",
    "integrateCopyLinkMessage": "Copiez le lien ci-dessous et partagez-le facilement à l'endroit souhaité.",
    "pageLabel": "Page {n}",
    "pageName": "Nom de la page",
    "pagePosition": "Position de la page",
    "createContactOnPartialSubmissionSubText": "Crée un contact lorsqu'un utilisateur clique sur « Suivant » sur n'importe quelle diapositive — même s'il ne termine pas le questionnaire.",
    "integratePopup": {
      "shareOrEmbed": "Intégrer ou partager le questionnaire",
      "share": {
        "openFormLink": "Ouvert le Lien du quiz"
      },
      "email": {
        "emailSubheader": "Créez un courriel vide et intégrer votre quiz."
      }
    }
  },
  "integrate": {
    "embed": {
      "chooseType": "Sélectionner le type",
      "sidebar": "Barre latérale",
      "popover": "Panneau",
      "popup": "Fenêtre contextuelle",
      "standard": "Standard",
      "formWidth": "Largeur du formulaire",
      "formHeight": "Hauteur du formulaire",
      "showLauncher": "Afficher le bouton {asset}",
      "showLauncherHelp": "Les visiteurs peuvent réduire et rouvrir l'élément {asset} à tout moment.",
      "position": "Choisir la position",
      "left": "Gauche",
      "right": "Droite",
      "buttonLabel": "Étiquette du bouton",
      "buttonColor": "Couleur du bouton",
      "buttonType": "Type de bouton",
      "buttonSize": "Taille du bouton",
      "text": "Texte",
      "iconAndText": "Icône + texte",
      "iconOnly": "Icône seulement",
      "small": "Petit",
      "medium": "Moyen",
      "large": "Large",
      "icon": "Icône",
      "cornerRadius": "Rayon d'angle",
      "linkCornerRadius": "Associer les valeurs de rayon d'angle",
      "corner": {
        "tl": "Rayon du coin supérieur gauche",
        "tr": "Rayon du coin supérieur droit",
        "bl": "Rayon du coin inférieur gauche",
        "br": "Rayon du coin inférieur droit"
      },
      "fontSize": "Taille de la police",
      "embedIn": "Intégrer dans",
      "funnels": "Entonnoirs",
      "websites": "Sites Web",
      "settingsTitle": "Paramètres d'intégration",
      "preview": "Aperçu",
      "previewHint": "Cliquez sur le bouton pour voir votre {type} en action",
      "realPreviewTitle": "Aperçu de votre {asset}",
      "realPreviewUnavailable": "Aperçu en direct non disponible. Affichage d'un exemple à la place.",
      "ghostName": "Nom",
      "ghostNamePlaceholder": "Entrez votre nom",
      "ghostPhone": "Numéro de téléphone",
      "ghostPhonePlaceholder": "+1 555 123-4567",
      "ghostEmail": "Adresse courriel",
      "ghostEmailPlaceholder": "exemple{'@'}gmail.com",
      "ghostSubmit": "Envoyer",
      "sidebarLower": "barre latérale",
      "popoverLower": "panneau",
      "popupLower": "fenêtre contextuelle",
      "standardLower": "formulaire standard",
      "general": "Général",
      "advanced": "Avancé",
      "embedCode": "Code d'intégration",
      "triggerType": "Type de déclencheur",
      "alwaysShow": "Toujours afficher",
      "showAfter": "Afficher après",
      "showOnScrolling": "Afficher lors du défilement",
      "activation": "Options d'activation",
      "alwaysActivated": "Toujours activé",
      "activateOnVisit": "Activer lors d'une visite",
      "deactivation": "Options de désactivation",
      "neverDeactivate": "Ne jamais désactiver",
      "deactivateAfter": "Désactiver après l'affichage",
      "leadCollected": "Lorsqu'un prospect est relevé",
      "modalTitle": "Intégrer dans une page Web",
      "copyStep": "Copier le code d'intégration",
      "openWebpageStep": "Ouvrez votre page Web",
      "openWebpageStepHelp": "Ouvrez l'éditeur de page et trouvez l'option permettant d'ajouter un code HTML ou personnalisé.",
      "publishStep": "Collez le code et publiez",
      "publishStepHelp": "Collez le code d'intégration dans la section de votre code HTML ou personnalisé, puis enregistrez et publiez votre page.",
      "copyCode": "Copier le code",
      "setupGuidePrompt": "Vous utilisez WordPress, Wix ou Webflow?",
      "viewSetupGuides": "Voir les guides de configuration"
    },
    "postSave": {
      "title": "Votre élément {asset} est prêt",
      "description": "Partagez-le, intégrez-le ou connectez-y un flux de travail quand vous voulez.",
      "embedForm": "Intégrer {asset}",
      "connect": "Connecter",
      "createWorkflow": "Créer un flux de travail",
      "workflowDescription": "Exécutez un flux de travail à chaque demande.",
      "dontShowAgain": "Ne la montrez plus"
    },
    "email": {
      "preview": "Aperçu",
      "shareViaEmail": "Partager par courriel",
      "startFromScratch": "Partir de zéro",
      "emailMarketingTemplates": "Modèles de marketing par courriel",
      "templateImageAlt": "2 000 et plus modèles de courriels",
      "yourTemplates": "Vos modèles",
      "selectTemplate": "Sélectionner parmi vos modèles",
      "to": "À :",
      "from": "De :",
      "inviteTitle": "Bonjour,",
      "inviteBody": "Je vous ai fait parvenir une invitation à remplir un formulaire :",
      "inviteAction": "Remplir notre formulaire"
    },
    "share": {
      "copyLink": "Partager le lien",
      "copyLinkTitle": "Copier le lien à votre {asset}",
      "copyLinkDescription": "Commencez à recueillir les demandes pour votre {asset}. Que vous vouliez partager le lien ou l'intégrer quelque part, nous sommes là pour vous aider.",
      "copyLinkButton": "Copier le lien",
      "openLink": "Ouvrir le lien",
      "shareOnSocialMedia": "Partager sur les médias sociaux",
      "socialDescription": "Partagez facilement votre {asset} sur vos plateformes de médias sociaux privilégiées et commencez à recueillir des demandes.",
      "qrCode": "Code QR",
      "shareQr": "Partager le code QR",
      "shareQrDescription": "Scannez ou partagez ce code QR pour accéder instantanément à votre {asset}.",
      "qrLoading": "Chargement du code QR...",
      "qrLoadError": "Impossible de charger le code QR. Veuillez réessayer.",
      "preview": "Aperçu",
      "social": {
        "facebook": "Partager sur Facebook",
        "whatsapp": "Partager sur WhatsApp",
        "linkedin": "Partager sur LinkedIn",
        "x": "Partager sur X"
      }
    }
  },
  "textEditor": {
    "textAlign": "Alignement du texte",
    "list": "Liste",
    "sourceCode": "Code source",
    "resetStyle": "Réinitialiser le style",
    "resetDocumentStyle": "Réinitialiser le style du document"
  },
  "builderValidation": {
    "ui": {
      "checking": "Vérification en cours",
      "actionRequired": "Action requise",
      "errorSummary": "Nombre d'erreurs à corriger avant que vous puissiez enregistrer : {n}. Sélectionnez-la pour accéder à l'erreur.",
      "viewErrors": "Afficher les erreurs",
      "panelTitle": "Recommandations ({n})",
      "panelSubtitle": "Conseils facultatifs pour améliorer votre {product}. Enregistrez à tout moment.",
      "tabRecommendations": "Recommandations",
      "tabInsights": "Aperçus",
      "recommendationsPill": "Recommandations",
      "noRecommendationsTitle": "Rien à vérifier",
      "noRecommendationsBody": "Ce produit {product} n'a aucune recommandation. Vous pouvez maintenant enregistrer.",
      "settingTitle": "Afficher {product} recommandations",
      "settingDescription": "Obtenez des recommandations intelligentes pour repérer les erreurs ignorées, améliorer votre produit {product} et stimuler plus de demandes",
      "dontShowAgain": "Ne plus afficher",
      "allClearTitle": "Tout est beau",
      "allClearBody": "Tout est corrigé. Vous pouvez maintenant enregistrer.",
      "openInsight": "Ouvrir les paramètres de {name}",
      "dontShowAgainHint": "Les recommandations de formulaire seront désactivées, mais vous pouvez les activer à tout moment dans l'onglet Paramètres.",
      "panelLabel": "Recommandations"
    },
    "errors": {
      "urlFieldDomainsMissing": "Un champ URL restreint les domaines, mais aucun n'est répertorié.",
      "pictureChoiceImageMissing": "Une sélection d'image n'a pas d'image.",
      "pictureChoiceLabelMissing": "Une sélection d'image n'a pas d'étiquette.",
      "pictureChoiceDuplicateLabels": "Deux sélections d'image ont la même étiquette.",
      "pictureChoiceSelectionLimitInvalid": "La limite de sélection d'images est supérieure au nombre d'options.",
      "datetimeLabelEmpty": "Un champ de date et d'heure n'a pas d'étiquette.",
      "datetimeTimeFormatInvalid": "Un champ de date et d'heure a une heure par défaut non valide.",
      "datetimeNoAvailableDays": "Un champ de date et d'heure n'a aucun jour disponible à sélectionner.",
      "datetimeDateRangeInvalid": "Un champ de date et d'heure comporte une période incomplète ou inversée.",
      "datetimeTimeRangeInvalid": "Un champ de date et d'heure comporte un intervalle de temps incomplet ou inversé.",
      "opportunitySettingsIncomplete": "Ce formulaire collecte les champs de l'opportunité, mais aucune étape du flux n'est définie.",
      "footerStylesInvalid": "Les paramètres du pied de page sont incomplets.",
      "emptyCustomFieldLabel": "Un champ personnalisé n'a pas d'étiquette.",
      "duplicateCustomFieldName": "Deux champs partagent l'étiquette « {name} ».",
      "sellProductsNoProduct": "Un élément de produit ne contient aucun produit ni produit complémentaire.",
      "imageMissing": "Un élément d'image n'a pas d'image.",
      "scoreCalculationEmpty": "Un élément de score n'a pas de champ dans son calcul."
    },
    "errorsInline": {
      "urlFieldDomainsMissing": "Aucun domaine ajouté",
      "pictureChoiceImageMissing": "Aucune image ajoutée",
      "pictureChoiceLabelMissing": "Étiquette manquante",
      "pictureChoiceDuplicateLabels": "Étiquette en double",
      "pictureChoiceSelectionLimitInvalid": "Limite de sélection non valide",
      "datetimeLabelEmpty": "Étiquette manquante",
      "datetimeTimeFormatInvalid": "Heure non valide",
      "datetimeNoAvailableDays": "Aucun jour sélectionné",
      "datetimeDateRangeInvalid": "Période non valide",
      "datetimeTimeRangeInvalid": "Intervalle de temps non valide",
      "opportunitySettingsIncomplete": "Étape de flux manquante",
      "footerStylesInvalid": "Paramètres du pied de page incomplets",
      "emptyCustomFieldLabel": "Étiquette manquante",
      "duplicateCustomFieldName": "Étiquette en double",
      "sellProductsNoProduct": "Aucun produit ajouté",
      "imageMissing": "Aucune image ajoutée",
      "scoreCalculationEmpty": "Aucun champ ajouté"
    },
    "errorsAction": {
      "urlFieldDomainsMissing": "Ajouter un domaine",
      "pictureChoiceImageMissing": "Ajouter une image",
      "pictureChoiceLabelMissing": "Ajouter une étiquette",
      "pictureChoiceDuplicateLabels": "Renommer l'étiquette en double",
      "pictureChoiceSelectionLimitInvalid": "Corriger la limite de sélection",
      "datetimeLabelEmpty": "Ajouter une étiquette",
      "datetimeTimeFormatInvalid": "Corriger l'heure par défaut",
      "datetimeNoAvailableDays": "Sélectionner les jours disponibles",
      "datetimeDateRangeInvalid": "Corriger la période",
      "datetimeTimeRangeInvalid": "Corriger l'intervalle de temps",
      "opportunitySettingsIncomplete": "Ouvrir les paramètres de l'opportunité",
      "footerStylesInvalid": "Ouvrir les paramètres du pied de page",
      "emptyCustomFieldLabel": "Ajouter une étiquette",
      "duplicateCustomFieldName": "Renommer l'étiquette en double",
      "sellProductsNoProduct": "Ajouter des produits",
      "imageMissing": "Ajouter une image",
      "scoreCalculationEmpty": "Ajouter des champs"
    },
    "recommendations": {
      "termsConditionsMissing": "Obtenez le consentement avant de stocker les données des visiteurs.",
      "captchaMissing": "Protégez ce formulaire contre les envois de pourriels.",
      "privacyPolicyUrlMissing": "Le texte du consentement contient toujours un lien vers exemple.com.",
      "sellProductsNotLive": "Comme le paiement est en mode test, aucun argent ne sera prélevé.",
      "defaultCustomFieldName": "Les étiquettes par défaut rendent les demandes difficiles à lire.",
      "emptyCustomFieldLabelExisting": "Comme un champ n'a pas d'étiquette, les visiteurs ne sauront pas quoi entrer.",
      "quizOptionPlaceholder": "Les réponses dans « {label} » utilisent toujours les noms d'option par défaut.",
      "quizScoreBlank": "Si une réponse n'a pas de score, elle ne comptera pas dans un résultat.",
      "quizCtaUrlMissing": "Le bouton de la page de résultats n'a pas de destination.",
      "quizCtaUrlPlaceholder": "Le bouton de la page de résultats contient toujours un lien vers exemple.com.",
      "headerTextEmpty": "Un élément de texte est vide.",
      "htmlElementEmpty": "Un élément HTML n'a pas de contenu.",
      "buttonTextEmpty": "Le bouton d'envoi n'a pas de texte.",
      "sourceFieldValueEmpty": "Comme un champ source masqué n'a pas de valeur, rien n'est suivi.",
      "optionLabelEmpty": "Une option de réponse n'a pas d'étiquette.",
      "fileUploadMaxSizeInvalid": "La limite de téléversement de fichiers n'est pas un nombre valide.",
      "submitRedirectUrlMissing": "Les demandes sont redirigées quelque part, mais aucune adresse n'est définie.",
      "submitRedirectUrlInvalid": "L'adresse de redirection après l'envoi n'est pas une URL valide.",
      "disqualifyUrlMissing": "Les visiteurs non admissibles sont redirigés, mais aucune adresse n'est définie.",
      "disqualifyMessageEmpty": "Un message vide s'affiche pour les visiteurs non admissibles.",
      "scheduleRedirectUrlInvalid": "Une adresse de redirection programmée n'est pas une URL valide.",
      "scheduleNoClosedStateContent": "Un état programmé n'affiche rien aux visiteurs.",
      "notificationRecipientMissing": "Les notifications par courriel sont activées, mais il n'y a pas de destinataire à qui les envoyer.",
      "notificationEmailInvalid": "L'adresse courriel du destinataire de la notification n'est pas valide.",
      "logicOrphanFieldReference": "Puisqu'une règle logique fait référence à un champ qui n'existe plus, elle ne s'exécute jamais.",
      "logicOrphanOptionReference": "Une règle logique fait référence à une option de réponse qui n'existe plus.",
      "logicOrphanTarget": "Une règle logique renvoie à une page qui n'existe plus.",
      "scoreCalculationInvalidReference": "Le calcul d'un score utilise un champ qui n'existe plus.",
      "assetHasNoElements": "Puisqu'aucune question n'a encore été ajoutée, il n'y a rien à collecter."
    },
    "recommendationsAction": {
      "termsConditionsMissing": "Ajouter un champ de conditions générales",
      "captchaMissing": "Ajouter une protection contre les bots",
      "privacyPolicyUrlMissing": "Mettre à jour les liens",
      "sellProductsNotLive": "Activer le mode en direct",
      "defaultCustomFieldName": "Renommer « {label} »",
      "emptyCustomFieldLabelExisting": "Ajouter une étiquette",
      "quizOptionPlaceholder": "Renommer les options",
      "quizScoreBlank": "Ajouter un score",
      "quizCtaUrlMissing": "Ajouter un lien",
      "quizCtaUrlPlaceholder": "Mettre à jour le lien",
      "headerTextEmpty": "Ajouter du texte",
      "htmlElementEmpty": "Ajouter du contenu",
      "buttonTextEmpty": "Ajoutez du texte à un bouton",
      "sourceFieldValueEmpty": "Ajouter une valeur",
      "optionLabelEmpty": "Ajouter une étiquette",
      "fileUploadMaxSizeInvalid": "Définir une limite",
      "submitRedirectUrlMissing": "Ajouter une URL de redirection",
      "submitRedirectUrlInvalid": "Corriger l'URL de redirection",
      "disqualifyUrlMissing": "Ajouter une URL de redirection",
      "disqualifyMessageEmpty": "Ajouter un message",
      "scheduleRedirectUrlInvalid": "Corriger l'URL de redirection",
      "scheduleNoClosedStateContent": "Ajouter du contenu",
      "notificationRecipientMissing": "Ajouter un destinataire",
      "notificationEmailInvalid": "Corriger l'adresse",
      "logicOrphanFieldReference": "Logique de révision",
      "logicOrphanOptionReference": "Logique de révision",
      "logicOrphanTarget": "Logique de révision",
      "scoreCalculationInvalidReference": "Corriger le calcul",
      "assetHasNoElements": "Ajoutez votre première question"
    },
    "insights": {
      "heading": "La configuration de votre formulaire en un coup d'œil.",
      "conditionalLogic": "Logique conditionnelle",
      "submitDestination": "Action lors de l'envoi",
      "customFields": "Champs personnalisés",
      "paymentMode": "Mode de paiement",
      "emailNotification": "Notification par courriel",
      "autoResponder": "Répondeur automatique",
      "quizCategories": "Catégories de questionnaires",
      "ruleCount": "{n} règles",
      "on": "Activé",
      "off": "Désactivé",
      "live": "En direct",
      "test": "Test",
      "destinationUrl": "URL de redirection",
      "destinationMessage": "Message",
      "destinationOrder": "Confirmation de commande",
      "destinationQuizResult": "Résultat du questionnaire"
    },
    "groups": {
      "fields": "Champs",
      "questions": "Questions",
      "questionsPage": "Page de questions",
      "resultsPage": "Page de résultats",
      "payments": "Paiements",
      "settings": "Paramètres"
    }
  }
}
